import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _typeof from '@babel/runtime/helpers/typeof';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import axios from 'axios';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { Message, Notification } from '@arco-design/web-react';
import { useLatest, useCreation, useUnmount, useMount, useUpdate } from '@ausz/hooks';
import { useEffect } from 'react';
import { io } from 'socket.io-client';

/* eslint-disable */
var Tween = {
  Linear: function Linear(t, b, c, d) {
    return c * t / d + b;
  },
  Quad: {
    easeIn: function easeIn(t, b, c, d) {
      return c * (t /= d) * t + b;
    },
    easeOut: function easeOut(t, b, c, d) {
      return -c * (t /= d) * (t - 2) + b;
    },
    easeInOut: function easeInOut(t, b, c, d) {
      if ((t /= d / 2) < 1) {
        return c / 2 * t * t + b;
      }
      return -c / 2 * (--t * (t - 2) - 1) + b;
    }
  },
  Cubic: {
    easeIn: function easeIn(t, b, c, d) {
      return c * (t /= d) * t * t + b;
    },
    easeOut: function easeOut(t, b, c, d) {
      return c * ((t = t / d - 1) * t * t + 1) + b;
    },
    easeInOut: function easeInOut(t, b, c, d) {
      if ((t /= d / 2) < 1) {
        return c / 2 * t * t * t + b;
      }
      return c / 2 * ((t -= 2) * t * t + 2) + b;
    }
  },
  Quart: {
    easeIn: function easeIn(t, b, c, d) {
      return c * (t /= d) * t * t * t + b;
    },
    easeOut: function easeOut(t, b, c, d) {
      return -c * ((t = t / d - 1) * t * t * t - 1) + b;
    },
    easeInOut: function easeInOut(t, b, c, d) {
      if ((t /= d / 2) < 1) {
        return c / 2 * t * t * t * t + b;
      }
      return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
    }
  },
  Quint: {
    easeIn: function easeIn(t, b, c, d) {
      return c * (t /= d) * t * t * t * t + b;
    },
    easeOut: function easeOut(t, b, c, d) {
      return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    },
    easeInOut: function easeInOut(t, b, c, d) {
      if ((t /= d / 2) < 1) {
        return c / 2 * t * t * t * t * t + b;
      }
      return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    }
  },
  Sine: {
    easeIn: function easeIn(t, b, c, d) {
      return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
    },
    easeOut: function easeOut(t, b, c, d) {
      return c * Math.sin(t / d * (Math.PI / 2)) + b;
    },
    easeInOut: function easeInOut(t, b, c, d) {
      return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
    }
  },
  Expo: {
    easeIn: function easeIn(t, b, c, d) {
      return t === 0 ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
    },
    easeOut: function easeOut(t, b, c, d) {
      return t === d ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
    },
    easeInOut: function easeInOut(t, b, c, d) {
      if (t === 0) {
        return b;
      }
      if (t === d) {
        return b + c;
      }
      if ((t /= d / 2) < 1) {
        return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
      }
      return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
    }
  },
  Circ: {
    easeIn: function easeIn(t, b, c, d) {
      return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
    },
    easeOut: function easeOut(t, b, c, d) {
      return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
    },
    easeInOut: function easeInOut(t, b, c, d) {
      if ((t /= d / 2) < 1) {
        return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
      }
      return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
    }
  },
  Elastic: {
    easeIn: function easeIn(t, b, c, d, a, p) {
      var s;
      if (t === 0) {
        return b;
      }
      if ((t /= d) === 1) {
        return b + c;
      }
      if (typeof p === 'undefined') {
        p = d * 0.3;
      }
      if (!a || a < Math.abs(c)) {
        s = p / 4;
        a = c;
      } else {
        s = p / (2 * Math.PI) * Math.asin(c / a);
      }
      return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    },
    easeOut: function easeOut(t, b, c, d, a, p) {
      var s;
      if (t === 0) {
        return b;
      }
      if ((t /= d) === 1) {
        return b + c;
      }
      if (typeof p === 'undefined') {
        p = d * 0.3;
      }
      if (!a || a < Math.abs(c)) {
        a = c;
        s = p / 4;
      } else {
        s = p / (2 * Math.PI) * Math.asin(c / a);
      }
      return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
    },
    easeInOut: function easeInOut(t, b, c, d, a, p) {
      var s;
      if (t === 0) {
        return b;
      }
      if ((t /= d / 2) === 2) {
        return b + c;
      }
      if (typeof p === 'undefined') {
        p = d * (0.3 * 1.5);
      }
      if (!a || a < Math.abs(c)) {
        a = c;
        s = p / 4;
      } else {
        s = p / (2 * Math.PI) * Math.asin(c / a);
      }
      if (t < 1) {
        return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
      }
      return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b;
    }
  },
  Back: {
    easeIn: function easeIn(t, b, c, d, s) {
      if (typeof s === 'undefined') {
        s = 1.70158;
      }
      return c * (t /= d) * t * ((s + 1) * t - s) + b;
    },
    easeOut: function easeOut(t, b, c, d, s) {
      if (typeof s === 'undefined') {
        s = 1.70158;
      }
      return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    },
    easeInOut: function easeInOut(t, b, c, d, s) {
      if (typeof s === 'undefined') {
        s = 1.70158;
      }
      if ((t /= d / 2) < 1) {
        return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
      }
      return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    }
  },
  Bounce: {
    easeIn: function easeIn(t, b, c, d) {
      return c - Tween.Bounce.easeOut(d - t, 0, c, d) + b;
    },
    easeOut: function easeOut(t, b, c, d) {
      if ((t /= d) < 1 / 2.75) {
        return c * (7.5625 * t * t) + b;
      } else if (t < 2 / 2.75) {
        return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
      } else if (t < 2.5 / 2.75) {
        return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
      } else {
        return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
      }
    },
    easeInOut: function easeInOut(t, b, c, d) {
      if (t < d / 2) {
        return Tween.Bounce.easeIn(t * 2, 0, c, d) * 0.5 + b;
      } else {
        return Tween.Bounce.easeOut(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
      }
    }
  }
};
var Tween$1 = Tween;

/**
 * @description animation library
 * @detail requestAnimationFrame
 * @param from
 * @param to
 * @param duration 持续事件，单位 s 秒
 * @param type 动画类型
 * @param delay 延迟时间，单位 s 秒
 */
var animationId = -1;
var stoppedAnimationId = animationId - 1;
var customAnimation = {
  to: function to(from, _to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.3;
    var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Linear';
    var delay = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var onComplete = arguments.length > 5 ? arguments[5] : undefined;
    var onUpdate = arguments.length > 6 ? arguments[6] : undefined;
    var cancel;
    var cancelToken = new Promise(function (resolve) {
      cancel = resolve;
    });
    var count = Object.keys(_to).length;
    var times = 0;
    for (var key in _to) {
      if (Object.prototype.hasOwnProperty.call(_to, key)) {
        setTimeout(
        // eslint-disable-next-line no-loop-func
        function (prop) {
          return function () {
            TweenAnimation(from[prop], _to[prop], duration, type, function (value, completed) {
              var newValue = value;
              if (onUpdate) {
                var patchValue = onUpdate(prop, value);
                // 如果 onUpdate 函数有数值型返回值，则认为外部需要个性修改，则适用该值
                if (typeof patchValue === 'number') {
                  newValue = patchValue;
                }
              }
              from[prop] = newValue;
              if (completed && onComplete) {
                times += 1;
                if (times === count) {
                  onComplete(newValue);
                }
              }
            }, cancelToken);
          };
        }(key), delay * 1000);
      }
    }
    return cancel;
  }
};
// duration unit second
function TweenAnimation(from, to, duration, type, callback, cancelToken) {
  var cancel = false;
  cancelToken.then(function () {
    cancel = true;
  });
  var selfAnimationId = ++animationId;
  var frameCount = Math.ceil(duration * 1000 / 17);
  var start = -1;
  var lastTime = Date.now();
  var options = {
    callback: function callback() {},
    type: 'Linear'
  };
  if (callback) {
    options.callback = callback;
  }
  if (type) {
    options.type = type;
  }
  var arrKeyTween = options.type.split('.');
  var tweenFn;
  if (arrKeyTween.length === 1) {
    // @ts-ignore
    tweenFn = Tween$1[arrKeyTween[0]];
  } else if (arrKeyTween.length === 2) {
    // @ts-ignore
    tweenFn = Tween$1[arrKeyTween[0]] && Tween$1[arrKeyTween[0]][arrKeyTween[1]];
  }
  var step = function step() {
    if (cancel) {
      return;
    }
    var currentTime = Date.now();
    var interval = currentTime - lastTime;
    var fps;
    if (interval) {
      fps = Math.ceil(1000 / interval);
    } else {
      requestAnimationFrame(step);
      return;
    }
    if (fps >= 30) {
      start++;
    } else {
      var _start = Math.floor(interval / 17);
      start = start + _start;
    }
    var value = tweenFn(start, from, to - from, frameCount);
    if (start <= frameCount && selfAnimationId > stoppedAnimationId) {
      // 动画继续
      options.callback(value);
      requestAnimationFrame(step);
    } else if (start > frameCount && selfAnimationId > stoppedAnimationId) {
      // 动画结束
      options.callback(to, true);
    }
    lastTime = Date.now();
  };
  step();
}
function stopAllAnimation() {
  stoppedAnimationId = animationId;
}

var TypeUtils = /*#__PURE__*/function () {
  function TypeUtils() {
    _classCallCheck(this, TypeUtils);
  }
  _createClass(TypeUtils, null, [{
    key: "isArray",
    value: function isArray(a) {
      return Array.isArray(a);
    }
  }, {
    key: "isObject",
    value: function isObject(o) {
      return _typeof(o) === 'object' && o !== null;
    }
  }, {
    key: "isDictObject",
    value: function isDictObject(obj) {
      return Object.prototype.toString.call(obj) === '[object Object]';
    }
  }, {
    key: "isPlainObject",
    value: function isPlainObject(obj) {
      if (Object.prototype.toString.call(obj) !== '[object Object]') {
        return false;
      }
      var prototype = Object.getPrototypeOf(obj);
      return prototype === null || prototype === Object.prototype;
    }
  }, {
    key: "isEmptyObject",
    value: function isEmptyObject(obj) {
      var arr = Object.keys(obj);
      return arr.length === 0;
    }
  }, {
    key: "isNumber",
    value: function isNumber(n) {
      return typeof n === 'number';
    }
  }, {
    key: "isDefined",
    value: function isDefined(obj) {
      return typeof obj !== 'undefined';
    }
  }, {
    key: "isStringArray",
    value: function isStringArray(data) {
      if (!data.length) {
        return false;
      }
      return data.every(function (item) {
        return typeof item === 'string';
      });
    }
  }]);
  return TypeUtils;
}();

function merge(target) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return args.reduce(function (acc, cur) {
    var keys = Object.keys(cur);
    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      var val = cur[key];
      if (TypeUtils.isDictObject(val)) {
        // @ts-ignore
        Reflect.set(acc, key, merge(acc[key] ? acc[key] : {}, val));
      } else if (TypeUtils.isArray(val)) {
        // @ts-ignore
        Reflect.set(acc, key, val.slice());
      } else {
        acc[key] = val;
      }
    }
    return acc;
  }, target);
}
function curry(fn) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var length = fn.length;
  // eslint-disable-next-line func-names
  return function () {
    // eslint-disable-next-line prefer-rest-params
    var newArgs = [].concat(_toConsumableArray(args), _toConsumableArray(Array.from(arguments)));
    if (newArgs.length < length) {
      // @ts-ignore
      return curry.call(this, fn, newArgs);
    }
    // @ts-ignore
    return fn.apply(this, newArgs);
  };
}
function applyOn(target, func) {
  var recursive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var filter = arguments.length > 3 ? arguments[3] : undefined;
  var applyFilter = function applyFilter(obj) {
    if (filter) {
      return filter(obj) && func(obj) || obj;
    }
    return func(obj);
  };
  function applyFunc(obj) {
    if (!TypeUtils.isObject(obj) || TypeUtils.isEmptyObject(obj)) {
      return applyFilter(obj);
    }
    var newObj = TypeUtils.isArray(obj) ? _toConsumableArray(obj) : Object.assign({}, obj);
    for (var prop in newObj) {
      if (Object.prototype.hasOwnProperty.call(newObj, prop)) {
        // @ts-ignore
        var value = newObj[prop];
        if (recursive && TypeUtils.isObject(value)) {
          if (filter && filter(value)) {
            value = applyFilter(value);
          } else {
            value = applyFunc(value);
          }
        } else {
          value = applyFilter(value);
        }
        // @ts-ignore
        newObj[prop] = value;
      }
    }
    return newObj;
  }
  return applyFunc(target);
}
function omit(obj) {
  var shallowCopy = Object.assign({}, obj);
  for (var i = 0; i < (arguments.length <= 1 ? 0 : arguments.length - 1); i += 1) {
    var key = i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1];
    delete shallowCopy[key];
  }
  return shallowCopy;
}
function pick(obj) {
  var result = {};
  for (var i = 0; i < (arguments.length <= 1 ? 0 : arguments.length - 1); i += 1) {
    var key = i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1];
    result[key] = obj[key];
  }
  return result;
}
/**
 * 深度比较两个对象是否相等
 * @param source 对象一
 * @param comparison 对象二
 * @param depth 深度，默认为只展开一层，即浅比较，完全深比较，传 Infinity
 * @returns boolean
 */
function equal(source, comparison) {
  var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  if (!TypeUtils.isObject(source) || !TypeUtils.isObject(comparison)) {
    return source === comparison;
  }
  var isSourceArray = TypeUtils.isArray(source);
  var isComparisonArray = TypeUtils.isArray(comparison);
  var isSourceObject = TypeUtils.isDictObject(source);
  var isComparisonObject = TypeUtils.isDictObject(comparison);
  if (isSourceArray !== isComparisonArray || isSourceObject !== isComparisonObject) {
    return false;
  }
  if (isSourceArray && source.length !== comparison.length) {
    return false;
  }
  if (isSourceObject && Object.keys(source).length !== Object.keys(comparison).length) {
    return false;
  }
  var curDepth = depth - 1;
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      var sourceEle = source[key];
      var comparisonEle = comparison[key];
      var isEqual = curDepth > 0 ? equal(sourceEle, comparisonEle, curDepth) : sourceEle === comparisonEle;
      if (!isEqual) {
        return false;
      }
    }
  }
  return true;
}
function deepCopy(object) {
  return JSON.parse(JSON.stringify(object));
}
/**
 * @param array 子元素具有 id 属性的数组
 * @param attrName 指定id
 * @returns 以 id 作为 key 的对象
 */
function arrayToObject(array) {
  var attrName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  var res = {};
  array.forEach(function (item) {
    // @ts-ignore
    res[item[attrName]] = item;
  });
  return res;
}
function arrayToMap(array) {
  var map = new Map();
  array.forEach(function (item) {
    map.set(item, true);
  });
  return map;
}
function groupById(array) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return true;
  };
  var res = {};
  array.forEach(function (item) {
    // @ts-ignore
    var val = item[key];
    if (!res[val]) {
      res[val] = [];
    }
    if (filter(item)) {
      res[val].push(item);
    }
  });
  return res;
}
function deepFreeze(obj) {
  // 取回定义在 obj 上的属性名
  var propNames = Object.getOwnPropertyNames(obj);
  // 在冻结自身之前冻结属性
  propNames.forEach(function (name) {
    var prop = obj[name];
    // 如果 prop 是个对象，冻结它
    if (_typeof(prop) === 'object' && prop !== null) deepFreeze(prop);
  });
  // 冻结自身 (no-op if already frozen)
  return Object.freeze(obj);
}
function arrayDivision(list, size) {
  var newList = [];
  var counts = Math.ceil(list.length / size);
  for (var i = 0; i < counts; i += 1) {
    newList.push(list.splice(0, size));
  }
  return newList;
}
function arrayTotalize(arr, key) {
  var total = arr.map(function (item) {
    return item[key];
  }).reduce(function (pre, cur) {
    return pre + cur;
  }, 0);
  return total || 0;
}

/**
 * @description 创建一个具有唯一 array 值的数组，每个值不包含在其他给定的数组中
 * @example difference([3, 2, 1], [4, 2]) => [3, 1]
 */
function difference(target, source) {
  var result = [];
  for (var i = 0; i < target.length; i += 1) {
    var item = target[i];
    var isInclude = source.includes(item);
    if (!isInclude) {
      result.push(item);
    }
  }
  return result;
}
/**
 * @description 求多个数组之间交集
 * @example intersection([2, 1], [4, 2], [1, 2]) => [2]
 */
function intersection() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (!args.length) {
    return [];
  }
  var result = [];
  args.sort(function (a, b) {
    return a.length - b.length;
  });
  var minLengthArray = args[0];
  // 将数组转 map 结构，提高检索速度
  var argsMap = args.map(function (arg) {
    return arg.reduce(function (prev, cur) {
      return prev.set(cur, true);
    }, new Map());
  });
  for (var i = 0; i < minLengthArray.length; i += 1) {
    var targetValue = minLengthArray[i];
    var count = 0;
    for (var j = 1; j < argsMap.length; j += 1) {
      var currentMap = argsMap[j];
      if (!currentMap.has(targetValue)) {
        break;
      }
      count += 1;
    }
    if (count === argsMap.length - 1) {
      result.push(targetValue);
    }
  }
  return result;
}
/**
 * @description 将数组按指定属性去重
 * @param array 源数组
 * @param attr 属性名
 * @example distinct([
 * { a: 1, b: 2 },
 * { a: 1, b: 2 },
 * { a: 2, b: 3 },] ,'a')
 * =>
 * [
 * { a: 1, b: 2 },
 * { a: 2, b: 3 },]
 */
function distinct(array, attr) {
  var result = new Map();
  array.forEach(function (item) {
    if (!result.has(item[attr])) {
      result.set(item[attr], item);
    }
  });
  return Array.from(result.values());
}
/**
 *
 * @param array (string | number | string[] | number[])[]
 * @returns 数组去重
 */
function deduplicate(array) {
  if (array.length <= 1) {
    return array;
  }
  if (!Array.isArray(array[0])) {
    return Array.from(new Set(array));
  }
  var newArray = [];
  array.forEach(function (arr) {
    if (newArray.some(function (item) {
      return equal(arr, item);
    })) {
      return;
    }
    newArray.push(arr);
  });
  return newArray;
}
function toArray(arr) {
  return Array.isArray(arr) ? arr : [arr];
}
/**
 * @description if source include target then remove from array, otherwise add to array
 */
function toggle(source, target) {
  var newArray = source.slice();
  var targets = toArray(target);
  targets.forEach(function (item) {
    var index = newArray.indexOf(item);
    if (index !== -1) {
      newArray.splice(index, 1);
    } else {
      newArray.push(item);
    }
  });
  return newArray;
}
function remove(source, targets) {
  var newList = _toConsumableArray(source);
  for (var i = targets.length - 1; i >= 0; i -= 1) {
    var target = targets[i];
    var index = newList.indexOf(target);
    if (index !== -1) {
      newList.splice(index, 1);
    }
  }
  return newList;
}
function move(array, from, to) {
  var newArray = _toConsumableArray(array);
  var startIndex = to < 0 ? newArray.length + to : to;
  if (startIndex >= 0 && startIndex < newArray.length) {
    var item = newArray.splice(from, 1)[0];
    newArray.splice(startIndex, 0, item);
  }
  return newArray;
}
/**
 *
 * @example range(4) => [0,1,2,3]
 * @example range(1,3) => [1,2,3]
 */
function range(val, end) {
  if (val < 0) {
    throw new RangeError('Invalid array length');
  }
  if (!TypeUtils.isDefined(end)) {
    return Array.from(new Array(val).keys());
  }
  if (end < 0) {
    throw new RangeError('Invalid array length');
  }
  return Array.from(new Array(end + 1).keys()).slice(val);
}
/**
 * 返回更新的后的 array，不会影响传入的数组
 * @param array 要更新的数组
 * @param value 要更新的值
 * @param iteratee 比较哪个属性
 */
function toUpdateBy(array, value) {
  var iteratee = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (v) {
    return v;
  };
  var result = _toConsumableArray(array);
  var targetValue = iteratee(value);
  var index = array.findIndex(function (item) {
    return iteratee(item) === targetValue;
  });
  if (index === -1) {
    return result;
  }
  result.splice(index, 1, value);
  return result;
}

/* eslint-disable no-constructor-return */
var Color = /*#__PURE__*/function () {
  function Color(r, g, b) {
    _classCallCheck(this, Color);
    this.isColor = true;
    if (g === undefined && b === undefined) {
      return this.set(r);
    }
    if (r && typeof r === 'number' && typeof g === 'number' && typeof b === 'number') {
      return this.setRGB(r, g, b);
    }
  }
  _createClass(Color, [{
    key: "set",
    value: function set(value) {
      if (value && value instanceof Color) {
        this.copy(value);
      } else if (typeof value === 'number') {
        this.setHex(value);
      } else if (typeof value === 'string') {
        this.setStyle(value);
      }
      return this;
    }
  }, {
    key: "setHex",
    value: function setHex(hex) {
      var value = Math.floor(hex);
      // eslint-disable-next-line no-bitwise
      this.r = value >> 16 & 255;
      // eslint-disable-next-line no-bitwise
      this.g = value >> 8 & 255;
      // eslint-disable-next-line no-bitwise
      this.b = value & 255;
      return this;
    }
  }, {
    key: "setRGB",
    value: function setRGB(r, g, b) {
      this.r = r;
      this.g = g;
      this.b = b;
      return this;
    }
  }, {
    key: "setStyle",
    value: function setStyle(style) {
      var m = /^#([\dA-Fa-f]+)$/.exec(style);
      if (!m) {
        return this;
      }
      // hex color
      var hex = m[1];
      var size = hex.length;
      if (size === 3) {
        // #ff0
        this.r = parseInt(hex.charAt(0) + hex.charAt(0), 16);
        this.g = parseInt(hex.charAt(1) + hex.charAt(1), 16);
        this.b = parseInt(hex.charAt(2) + hex.charAt(2), 16);
        return this;
      }
      if (size === 6) {
        // #ff0000
        this.r = parseInt(hex.charAt(0) + hex.charAt(1), 16);
        this.g = parseInt(hex.charAt(2) + hex.charAt(3), 16);
        this.b = parseInt(hex.charAt(4) + hex.charAt(5), 16);
        return this;
      }
      return this;
    }
  }, {
    key: "getHex",
    value: function getHex() {
      // eslint-disable-next-line no-bitwise
      return this.r << 16 ^ this.g << 8 ^ this.b << 0;
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      // eslint-disable-next-line prefer-template
      return "#".concat(('000000' + this.getHex().toString(16)).slice(-6));
    }
  }, {
    key: "copy",
    value: function copy(color) {
      this.r = color.r;
      this.g = color.g;
      this.b = color.b;
      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Color(this.r, this.g, this.b);
    }
  }]);
  return Color;
}();

/* eslint-disable no-bitwise */
var ColorGenerator = /*#__PURE__*/function () {
  function ColorGenerator() {
    _classCallCheck(this, ColorGenerator);
  }
  _createClass(ColorGenerator, null, [{
    key: "getColors",
    value: function getColors(count) {
      var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var colors = [];
      for (var i = start; i < count + start; i += 1) {
        colors.push(ColorGenerator.getColor(i));
      }
      return colors;
    }
  }, {
    key: "getColor",
    value: function getColor(index) {
      var rgb = [0, 0, 0];
      for (var i = 0; i < 24; i += 1) {
        rgb[i % 3] <<= 1;
        rgb[i % 3] |= index & 0x01;
        // eslint-disable-next-line no-param-reassign
        index >>= 1;
      }
      var color = rgb.reduce(function (a, c) {
        return (c > 0x0f ? c.toString(16) : "0".concat(c.toString(16))) + a;
      }, '');
      return "#".concat(color);
    }
  }]);
  return ColorGenerator;
}();

/**
 * 封装存储本地 localStorage 相关操作
 */
var Config = /*#__PURE__*/function () {
  function Config(name, storage) {
    _classCallCheck(this, Config);
    this.name = name;
    this.storage = storage;
    if (window.localStorage[name] === undefined) {
      window.localStorage[name] = JSON.stringify(storage);
    } else {
      var data = JSON.parse(window.localStorage[name]);
      for (var key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          storage[key] = data[key];
        }
      }
    }
  }
  _createClass(Config, [{
    key: "getKey",
    value: function getKey(key) {
      return this.storage[key];
    }
  }, {
    key: "setKey",
    value: function setKey(key, value) {
      this.storage[key] = value;
      window.localStorage[this.name] = JSON.stringify(this.storage);
    }
  }, {
    key: "get",
    value: function get() {
      return this.storage;
    }
  }, {
    key: "set",
    value: function set(data) {
      var localFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      for (var key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          // 本地优先且已有值，则不进行字段新增或更新
          if (localFirst && TypeUtils.isDefined(this.storage[key])) {
            continue;
          }
          this.storage[key] = data[key];
        }
      }
      for (var _key in this.storage) {
        if (Object.prototype.hasOwnProperty.call(this.storage, _key) && !TypeUtils.isDefined(data[_key])) {
          // 缓存的失效的 key 进行删除
          delete this.storage[_key];
        }
      }
      window.localStorage[this.name] = JSON.stringify(this.storage);
    }
  }, {
    key: "clear",
    value: function clear() {
      delete window.localStorage[this.name];
    }
  }]);
  return Config;
}();

var DEG2RAD = Math.PI / 180;
var RAD2DEG = 180 / Math.PI;
var DOUBLE_PI = 2 * Math.PI;
var MathUtils = /*#__PURE__*/function () {
  function MathUtils() {
    _classCallCheck(this, MathUtils);
  }
  _createClass(MathUtils, null, [{
    key: "round",
    value: function round(num) {
      var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var base = Math.pow(10, precision);
      return Math.round(num * base) / base;
    }
  }, {
    key: "ceil",
    value: function ceil(num) {
      var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var base = Math.pow(10, precision);
      return Math.ceil(num * base) / base;
    }
  }, {
    key: "floor",
    value: function floor(num) {
      var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var base = Math.pow(10, precision);
      return Math.floor(num * base) / base;
    }
  }, {
    key: "format",
    value: function format(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
    /**
     * 获取小数点位数
     */
  }, {
    key: "getDecimals",
    value: function getDecimals(num) {
      if (Math.floor(num) === num) {
        return 0;
      }
      return num.toString().split('.')[1].length || 0;
    }
    /**
     * @description mapping degrees to [0, 360] 主要是为了满足前端 ui 习惯使用 0-360 表示角度的要求
     */
  }, {
    key: "normalizeDegrees",
    value: function normalizeDegrees(degrees) {
      var result = degrees % 360;
      if (result < 0) {
        result += 360;
      }
      return result;
    }
    /**
     * 返回符合 min、max 的 value 值
     * @param value
     * @param min
     * @param max
     * @returns 符合要求的值
     */
  }, {
    key: "clamp",
    value: function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }
    /**
     * @param low
     * @param high
     * @returns 返回指定范围内的随机整数值
     */
  }, {
    key: "randInt",
    value: function randInt(low, high) {
      return low + Math.floor(Math.random() * (high - low + 1));
    }
    /**
     * @param low
     * @param high
     * @param count
     * @returns 返回指定数量指定范围内的随机整数数组
     */
  }, {
    key: "randIntArray",
    value: function randIntArray(low, high, count) {
      var list = [];
      Array.from({
        length: count
      }, function () {
        return list.push(MathUtils.randInt(low, high));
      });
      return list;
    }
    /**
     * 角度转弧度
     * @param degrees 角度
     * @returns
     */
  }, {
    key: "degToRad",
    value: function degToRad(degrees) {
      return degrees * DEG2RAD;
    }
    /**
     * 弧度转角度
     * @param radians 弧度
     * @returns
     */
  }, {
    key: "radToDeg",
    value: function radToDeg(radians) {
      return radians * RAD2DEG;
    }
    /**
     * 将弧度规整到 [-2pi, 2pi] 之间
     * @param radians 弧度
     */
  }, {
    key: "normalizeRadiansInTwoPI",
    value: function normalizeRadiansInTwoPI(radians) {
      return radians % DOUBLE_PI;
    }
    /**
     * 将弧度规整到 [-pi, pi] 之间
     * @param radians 弧度
     */
  }, {
    key: "normalizeRadiansInPI",
    value: function normalizeRadiansInPI(radians) {
      // 规整一下角度
      var res = this.normalizeRadiansInTwoPI(radians);
      if (res > Math.PI) {
        res -= DOUBLE_PI;
      } else if (res < -Math.PI) {
        res += DOUBLE_PI;
      }
      return res;
    }
    /**
     *  @description 归于 [0, 2*PI]
     */
  }, {
    key: "normalizePositionAngle",
    value: function normalizePositionAngle(radians) {
      return (radians % DOUBLE_PI + DOUBLE_PI) % DOUBLE_PI;
    }
    /**
     * 计算两点间距离
     * @param point1
     * @param point2
     * @returns 长度
     */
  }, {
    key: "distance",
    value: function distance(point1, point2) {
      var distanceToSquared = MathUtils.distanceToSquared(point1, point2);
      return Math.sqrt(distanceToSquared);
    }
  }, {
    key: "distanceToSquared",
    value: function distanceToSquared(point1, point2) {
      var xSq = Math.pow(point1[0] - point2[0], 2);
      var ySq = Math.pow(point1[1] - point2[1], 2);
      return xSq + ySq;
    }
    /**
     * 计算两点的角度
     * @param start 起点
     * @param end 终点
     * @returns 逆时针为正，顺时针为负的 -180-180 之间的角度值
     */
  }, {
    key: "angle",
    value: function angle(start, end) {
      var dx = end[0] - start[0];
      var dy = end[1] - start[1];
      return MathUtils.radToDeg(Math.atan2(dy, dx));
    }
  }, {
    key: "radian",
    value: function radian(start, end) {
      return MathUtils.degToRad(MathUtils.angle(start, end));
    }
    /**
     * 两点之间中点坐标
     * @param point1
     * @param point2
     * @returns 两点之间中点坐标
     */
  }, {
    key: "mid",
    value: function mid(point1, point2) {
      var _point = _slicedToArray(point1, 2),
        x1 = _point[0],
        y1 = _point[1];
      var _point2 = _slicedToArray(point2, 2),
        x2 = _point2[0],
        y2 = _point2[1];
      var result = [x1 + (x2 - x1) / 2, y1 + (y2 - y1) / 2];
      if (point1.length === 3 && point2.length === 3) {
        result.push(point1[2] + (point2[2] - point1[2]) / 2);
      }
      return result;
    }
    /**
     * 两点是否相同
     */
  }, {
    key: "isEqual",
    value: function isEqual(point1, point2) {
      var _point3 = _slicedToArray(point1, 3),
        x1 = _point3[0],
        y1 = _point3[1],
        z1 = _point3[2];
      var _point4 = _slicedToArray(point2, 3),
        x2 = _point4[0],
        y2 = _point4[1],
        z2 = _point4[2];
      return x1 === x2 && y1 === y2 && z1 === z2;
    }
  }, {
    key: "isAlmostEqual",
    value: function isAlmostEqual(num1, num2) {
      var tolerance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1e-6;
      return Math.abs(num1 - num2) < tolerance;
    }
  }, {
    key: "isPointAlmostEqual",
    value: function isPointAlmostEqual(point1, point2) {
      var tolerance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1e-6;
      var _point5 = _slicedToArray(point1, 3),
        _point5$ = _point5[0],
        x1 = _point5$ === void 0 ? 0 : _point5$,
        _point5$2 = _point5[1],
        y1 = _point5$2 === void 0 ? 0 : _point5$2,
        _point5$3 = _point5[2],
        z1 = _point5$3 === void 0 ? 0 : _point5$3;
      var _point6 = _slicedToArray(point2, 3),
        _point6$ = _point6[0],
        x2 = _point6$ === void 0 ? 0 : _point6$,
        _point6$2 = _point6[1],
        y2 = _point6$2 === void 0 ? 0 : _point6$2,
        _point6$3 = _point6[2],
        z2 = _point6$3 === void 0 ? 0 : _point6$3;
      return MathUtils.isAlmostEqual(x1, x2, tolerance) && MathUtils.isAlmostEqual(y1, y2, tolerance) && MathUtils.isAlmostEqual(z1, z2, tolerance);
    }
    /**
     * 线性插值
     */
  }, {
    key: "lerp",
    value: function lerp(min, max, ratio) {
      return min + (max - min) * ratio;
    }
    /**
     * 判断 x 是否在开区间内
     */
  }, {
    key: "inRange",
    value: function inRange(x, start, end) {
      var tolerance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var _sort = [start, end].sort(function (a, b) {
          return a - b;
        }),
        _sort2 = _slicedToArray(_sort, 2),
        s = _sort2[0],
        e = _sort2[1];
      return x > s - tolerance && x < e + tolerance;
    }
    /**
     * 判断 x 是否在闭区间内
     */
  }, {
    key: "inClosedRange",
    value: function inClosedRange(x, start, end) {
      var tolerance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var _sort3 = [start, end].sort(function (a, b) {
          return a - b;
        }),
        _sort4 = _slicedToArray(_sort3, 2),
        s = _sort4[0],
        e = _sort4[1];
      return x >= s - tolerance && x <= e + tolerance;
    }
    /**
     * 判断 radians 所在区间，返回水平/垂直角度
     */
  }, {
    key: "alongAxis",
    value: function alongAxis(radians) {
      if (MathUtils.inRange(radians, -Math.PI / 4, Math.PI / 4)) {
        return 0;
      }
      if (MathUtils.inRange(radians, Math.PI / 4, Math.PI * 3 / 4)) {
        return Math.PI / 2;
      }
      if (MathUtils.inRange(radians, -(Math.PI * 3) / 4, -Math.PI / 4)) {
        return Math.PI * 3 / 2;
      }
      return Math.PI;
    }
  }]);
  return MathUtils;
}();

var DateUtils = /*#__PURE__*/function () {
  function DateUtils() {
    _classCallCheck(this, DateUtils);
  }
  _createClass(DateUtils, null, [{
    key: "getDescription",
    value:
    /**
     * @examples 15分钟前, 2小时后
     */
    function getDescription(time, cur) {
      var diff = DateUtils.diff(cur || Date.now(), time);
      var suffix = diff > 0 ? '前' : '后';
      var delta = Math.abs(diff);
      var minutes = MathUtils.round(DateUtils.parse(delta, 'min'));
      if (minutes < 1) {
        return '刚刚';
      }
      var hours = DateUtils.parse(delta, 'hr');
      if (hours < 1) {
        return "".concat(MathUtils.round(minutes, 0), "\u5206\u949F").concat(suffix);
      }
      var days = DateUtils.parse(delta, 'day');
      if (days < 1) {
        return "".concat(MathUtils.round(hours, 0), "\u5C0F\u65F6").concat(suffix);
      }
      var months = DateUtils.parse(delta, 'month');
      if (months < 1) {
        return "".concat(MathUtils.round(days, 0), "\u5929").concat(suffix);
      }
      var years = DateUtils.parse(delta, 'year');
      if (years < 1) {
        return "".concat(MathUtils.round(months, 0), "\u4E2A\u6708").concat(suffix);
      }
      return "".concat(MathUtils.round(years, 0), "\u5E74").concat(suffix);
    }
    /**
     * @examples 10月24日
     */
  }, {
    key: "format",
    value: function format(time) {
      var showCurYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var curYear = new Date(Date.now()).getFullYear();
      var date = new Date(time);
      var year = date.getFullYear();
      var month = date.getMonth() + 1; // 0 表示一月
      var day = date.getDate();
      var yearStr = !showCurYear && year === curYear ? '' : "".concat(year, "\u5E74");
      var str = "".concat(yearStr).concat(month, "\u6708").concat(day, "\u65E5");
      return str;
    }
    /**
     * @param joint 日期连接符，default = '-'
     * @examples '2023-5-5 14:16:09'
     */
  }, {
    key: "normalize",
    value: function normalize(time) {
      var joint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
      return new Date(time).toLocaleString().replace(/\//g, joint);
    }
  }, {
    key: "diff",
    value: function diff(timeA, timeB) {
      var delta = new Date(timeA).getTime() - new Date(timeB).getTime();
      return delta;
    }
  }, {
    key: "parse",
    value: function parse(milliseconds, unit) {
      switch (unit) {
        case 'ms':
          {
            return milliseconds;
          }
        case 's':
          {
            return milliseconds / 1000;
          }
        case 'min':
          {
            return milliseconds / 1000 / 60;
          }
        case 'hr':
          {
            return milliseconds / 1000 / 60 / 60;
          }
        case 'day':
          {
            return milliseconds / 1000 / 60 / 60 / 24;
          }
        case 'month':
          {
            return milliseconds / 1000 / 60 / 60 / 24 / 30;
          }
        case 'year':
          {
            return milliseconds / 1000 / 60 / 60 / 24 / 365;
          }
        default:
          return milliseconds;
      }
    }
  }]);
  return DateUtils;
}();

var DomUtils = /*#__PURE__*/function () {
  function DomUtils() {
    _classCallCheck(this, DomUtils);
  }
  _createClass(DomUtils, null, [{
    key: "blur",
    value: function blur() {
      var ele = document.activeElement;
      if (ele instanceof HTMLElement) {
        ele.blur();
      }
    }
  }, {
    key: "isInEditableElement",
    value: function isInEditableElement(e) {
      var element = e.target;
      if (!element) {
        return false;
      }
      return e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement || element.contentEditable && element.contentEditable === 'true';
    }
  }, {
    key: "copy",
    value: function copy(text) {
      var _a;
      if ((_a = navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText) {
        return navigator.clipboard.writeText(text);
      }
      var span = document.createElement('span');
      span.textContent = text;
      span.style.whiteSpace = 'pre';
      document.body.append(span);
      var selection = window.getSelection();
      var range = window.document.createRange();
      selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
      range.selectNode(span);
      selection === null || selection === void 0 ? void 0 : selection.addRange(range);
      var success = false;
      try {
        success = window.document.execCommand('copy');
      } catch (err) {
        // eslint-disable-next-line
        console.log('error', err);
      }
      selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
      window.document.body.removeChild(span);
      return success ? Promise.resolve() : Promise.reject(new DOMException('Failed to copy'));
    }
  }]);
  return DomUtils;
}();

var UrlUtils = /*#__PURE__*/function () {
  function UrlUtils() {
    _classCallCheck(this, UrlUtils);
  }
  _createClass(UrlUtils, null, [{
    key: "getFileName",
    value: function getFileName(url) {
      var lastIndexOfDivider = url.lastIndexOf('/');
      return url.substring(lastIndexOfDivider + 1);
    }
    /**
     * @description 判断是不是合法的 url 字符串。FIXME:判断有问题
     * @param path 待判断的 url 字符串
     */
  }, {
    key: "isUrl",
    value: function isUrl(path) {
      var reg = /(((^https?:(?:\/\/)?)(?:[\w$&+,:;=-]+@)?[\d.A-Za-z-]+(?::\d+)?|(?:www.|[\w$&+,:;=-]+@)[\d.A-Za-z-]+)((?:\/[%+./~\w-_]*)?\??[\w%&+.;=@-]*#?\w*)?)$/;
      return reg.test(path);
    }
  }, {
    key: "isRelativePath",
    value: function isRelativePath(path) {
      return !path.startsWith('/');
    }
    /**
     * @description 判断是不是相对协议的路径的，eg：//baidu.com 将返回 true
     * @param url 待判断的 url 字符串
     */
  }, {
    key: "isRelativeProtocolUrl",
    value: function isRelativeProtocolUrl(url) {
      var newUrl = "https:".concat(url);
      return this.isUrl(newUrl);
    }
    /**
     * @description 根据相对路径推测出完整路径
     * @param url 待补全的 url 字符串
     */
  }, {
    key: "getFullRequestUrl",
    value: function getFullRequestUrl(url) {
      var _window$location = window.location,
        protocol = _window$location.protocol,
        origin = _window$location.origin,
        pathname = _window$location.pathname;
      if (this.isUrl(url)) {
        return url;
      }
      if (this.isRelativeProtocolUrl(url)) {
        return protocol + url;
      }
      var isRelativePath = this.isRelativePath(url);
      var baseUrl = isRelativePath ? "".concat(origin).concat(pathname) : origin;
      return this.toAbsoluteUrl(baseUrl, url);
    }
    /**
     * @description 获取 pathname，等同于 location.pathname，没有 origin、search 和 hash 的部分
     * @author Ethan
     * @static
     */
  }, {
    key: "getPathname",
    value: function getPathname(url) {
      var link = document.createElement('a');
      link.href = url;
      return link.pathname;
    }
    /**
     * @description 判断是不是 ip 路径
     * @param url
     */
  }, {
    key: "isIpPath",
    value: function isIpPath(url) {
      var reg = /((25[0-5]|2[0-4]\d|1?\d?\d)\.){3}(25[0-5]|2[0-4]\d|1?\d?\d)/;
      return reg.test(url);
    }
  }, {
    key: "toAbsoluteUrl",
    value: function toAbsoluteUrl(baseUrl) {
      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (this.isUrl(url)) {
        return url;
      }
      var normalizeBaseUrl = this.removeTrailingSlash(baseUrl);
      return url[0] === '/' ? "".concat(normalizeBaseUrl).concat(url) : "".concat(normalizeBaseUrl, "/").concat(url);
    }
  }, {
    key: "toRelativeUrl",
    value: function toRelativeUrl(baseUrl) {
      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var res = url;
      if (this.isUrl(url)) {
        res = url.substring(baseUrl.length);
      }
      return res[0] === '/' ? res : "/".concat(res);
    }
  }, {
    key: "toQueryString",
    value: function toQueryString(obj) {
      var str = [];
      if (obj !== null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== undefined && obj[key] !== null) {
            str.push("".concat(key, "=").concat(encodeURIComponent(obj[key])));
          }
        }
      }
      if (str.length) {
        return "?".concat(str.join('&'));
      }
      return '';
    }
  }, {
    key: "removeTrailingSlash",
    value: function removeTrailingSlash(path) {
      if (!path) {
        return '';
      }
      // Remove any whitespace before or after string
      var trimmed = path.replace(/^\s+|\s+$/gm, '');
      // Remove trailing slash(es)
      trimmed = trimmed.replace(/\/+$/, '');
      return trimmed;
    }
  }]);
  return UrlUtils;
}();

var EnvUtils = /*#__PURE__*/function () {
  function EnvUtils() {
    _classCallCheck(this, EnvUtils);
  }
  _createClass(EnvUtils, null, [{
    key: "removePort",
    value: function removePort(url) {
      return url.replace(/:\d+/g, '');
    }
    /**
     * @description 如果不是 ip 形式，则移除里面的端口号
     */
  }, {
    key: "removePortIfNotIp",
    value: function removePortIfNotIp(url) {
      if (UrlUtils.isIpPath(url)) {
        return url;
      }
      return this.removePort(url);
    }
  }, {
    key: "normalize",
    value: function normalize(url) {
      var res = EnvUtils.removePortIfNotIp(url);
      // 没有协议，则补一个 http:
      if (!/^http/.test(res)) {
        var isRelative = /^\/\//.test(res);
        res = (isRelative ? 'http:' : 'http://') + res;
      }
      return res;
    }
  }]);
  return EnvUtils;
}();

var EventDispatcher = /*#__PURE__*/function () {
  function EventDispatcher() {
    _classCallCheck(this, EventDispatcher);
    this.listeners = new Map();
    this.tracedTypeSet = new Set();
  }
  _createClass(EventDispatcher, [{
    key: "addEventListener",
    value: function addEventListener(type, listener) {
      var handlers = this.listeners.get(type);
      if (!handlers) {
        handlers = [];
        this.listeners.set(type, handlers);
      }
      if (!handlers.includes(listener)) {
        handlers.push(listener);
      }
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, listener) {
      var handlers = this.listeners.get(type);
      if (handlers) {
        var index = handlers.indexOf(listener);
        if (index !== -1) {
          handlers.splice(index, 1);
        }
      }
    }
  }, {
    key: "hasEventListener",
    value: function hasEventListener(type, listener) {
      var handlers = this.listeners.get(type);
      if (!handlers) {
        return false;
      }
      return handlers.includes(listener);
    }
  }, {
    key: "getEventListeners",
    value: function getEventListeners(type) {
      return this.listeners.get(type);
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(event) {
      var handlers = this.listeners.get(event.type);
      if (handlers !== undefined) {
        event.target = this;
        // Make a copy, in case listeners are removed while iterating.
        var array = handlers.slice(0);
        for (var i = 0, l = array.length; i < l; i += 1) {
          array[i].call(this, event);
        }
        event.target = null;
      }
      this.log(event);
    }
    /**
     * @description 方便调试时查看事件调用情况
     * @param types 关心的事件调用情况
     */
  }, {
    key: "trace",
    value: function trace() {
      var _this = this;
      var types = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      types.forEach(function (item) {
        return _this.tracedTypeSet.add(item);
      });
    }
  }, {
    key: "log",
    value: function log(ev) {
      if (this.tracedTypeSet.has(ev.type)) {
        var listeners = this.getEventListeners(ev.type) || [];
        // eslint-disable-next-line no-console
        console.log("".concat(ev.type, " event executed ").concat(listeners.length, " listeners"));
        // eslint-disable-next-line no-console
        console.log(listeners);
      }
    }
  }]);
  return EventDispatcher;
}();

function dataURLToBlob(strUrl) {
  var parts = strUrl.split(/[,:;]/);
  var type = parts[1];
  var decoder = parts[2] === 'base64' ? atob : decodeURIComponent;
  var binData = decoder(parts.pop());
  var mx = binData.length;
  var uiArr = new Uint8Array(mx);
  for (var i = 0; i < mx; i += 1) {
    uiArr[i] = binData.charCodeAt(i);
  }
  return new window.Blob([uiArr], {
    type: type
  });
}
var FileUtils = /*#__PURE__*/function () {
  function FileUtils() {
    _classCallCheck(this, FileUtils);
  }
  _createClass(FileUtils, null, [{
    key: "download",
    value: function download(fileName, data) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'url';
      var isRawBlobData = data instanceof Blob;
      var url = isRawBlobData ? '' : data;
      if (isRawBlobData) {
        url = window.URL.createObjectURL(data);
      } else if (type === 'blob') {
        var blob = new Blob([data]);
        url = window.URL.createObjectURL(blob);
      } else if (type === 'dataURL') {
        var _blob = dataURLToBlob(data);
        url = window.URL.createObjectURL(_blob);
      }
      var anchor = document.createElement('a');
      anchor.download = fileName;
      anchor.href = url;
      // Firefox 只允许文档内链接点击事件
      document.body.append(anchor);
      var handler = function handler(e) {
        e.stopPropagation();
        anchor.removeEventListener('click', handler);
      };
      anchor.addEventListener('click', handler);
      anchor.click();
      document.body.removeChild(anchor);
    }
  }, {
    key: "getFormatFromPath",
    value: function getFormatFromPath(path) {
      var lastIndex = path.lastIndexOf('.');
      return path.substring(lastIndex + 1);
    }
  }, {
    key: "getNameFromPath",
    value: function getNameFromPath(path) {
      var lastIndex = path.lastIndexOf('/');
      return path.substring(lastIndex + 1);
    }
    /**
     * @description 问题：a标签的链接跨域时，download属性失效，例如图片、txt等格式将直接在浏览器打开而不是下载
     * @description 解决办法：需要将文件使用get请求获取到，转为blob，获取blob的url再赋值给a标签
     */
  }, {
    key: "downloadFromCrossOrigin",
    value: function downloadFromCrossOrigin(url, fileName) {
      return new Promise(function (resolve) {
        axios({
          method: 'get',
          url: url,
          responseType: 'blob'
        }).then(function (response) {
          resolve();
          if (!response.data) {
            return;
          }
          var fileUrl = window.URL.createObjectURL(new Blob([response.data]));
          FileUtils.download(fileName, fileUrl, 'url');
        });
      });
    }
  }]);
  return FileUtils;
}();
FileUtils.dataURLtoFile = function (dataUrl, fileName) {
  var arr = dataUrl.split(';base64,'); // [data:image/png,xxx]
  var mime = arr[0].replace('data:', ''); // mime后端识别用的文件格式数据
  var fileType = mime.split('/').pop(); // 获取文件格式
  var bstr = atob(arr[1]); // base64解码,创建Unicode编码的数组对象，每个值都是Unicode
  var u8arr = new Uint8Array(bstr.split('').map(function (str) {
    return str.charCodeAt(0);
  }));
  return new File([u8arr], "".concat(fileName !== null && fileName !== void 0 ? fileName : 'file', ".").concat(fileType), {
    type: mime
  });
};
var FileUtils$1 = FileUtils;

var nanoid = function nanoid() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 21;
  var id = '';
  var bytes = crypto.getRandomValues(new Uint8Array(size));
  while (size--) {
    var byte = bytes[size] & 63;
    if (byte < 36) {
      id += byte.toString(36);
    } else if (byte < 62) {
      id += (byte - 26).toString(36).toUpperCase();
    } else if (byte < 63) {
      id += '_';
    } else {
      id += '-';
    }
  }
  return id;
};

var IdUtils = /*#__PURE__*/function () {
  function IdUtils() {
    _classCallCheck(this, IdUtils);
  }
  _createClass(IdUtils, null, [{
    key: "generate",
    value:
    /**
     * @description
     * @param size 字符长度，nanoid 默认生成 21 位，查看已有代码使用 15 居多，直接入参默认 15 位
     * @returns 返回唯一的字符串 id
     */
    function generate() {
      var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 15;
      return nanoid(size);
    }
  }]);
  return IdUtils;
}();

var _KeyCodeMap;
var KeyCodeEnum;
(function (KeyCodeEnum) {
  KeyCodeEnum["Escape"] = "Escape";
  KeyCodeEnum["Tab"] = "Tab";
  KeyCodeEnum["AltLeft"] = "AltLeft";
  KeyCodeEnum["AltRight"] = "AltRight";
  KeyCodeEnum["ShiftLeft"] = "ShiftLeft";
  KeyCodeEnum["ShiftRight"] = "ShiftRight";
  KeyCodeEnum["CtrlLeft"] = "ControlLeft";
  KeyCodeEnum["CtrlRight"] = "ControlRight";
  KeyCodeEnum["CommandLeft"] = "MetaLeft";
  KeyCodeEnum["CommandRight"] = "MetaRight";
  KeyCodeEnum["Space"] = "Space";
  KeyCodeEnum["Delete"] = "Delete";
  KeyCodeEnum["Backspace"] = "Backspace";
  KeyCodeEnum["Enter"] = "Enter";
  KeyCodeEnum["NumpadEnter"] = "NumpadEnter";
  KeyCodeEnum["F1"] = "F1";
  KeyCodeEnum["F2"] = "F2";
  KeyCodeEnum["F3"] = "F3";
  KeyCodeEnum["F4"] = "F4";
  KeyCodeEnum["F5"] = "F5";
  KeyCodeEnum["F6"] = "F6";
  KeyCodeEnum["F7"] = "F7";
  KeyCodeEnum["F8"] = "F8";
  KeyCodeEnum["F9"] = "F9";
  KeyCodeEnum["F10"] = "F10";
  KeyCodeEnum["F11"] = "F11";
  KeyCodeEnum["F12"] = "F12";
  KeyCodeEnum["A"] = "KeyA";
  KeyCodeEnum["B"] = "KeyB";
  KeyCodeEnum["C"] = "KeyC";
  KeyCodeEnum["D"] = "KeyD";
  KeyCodeEnum["E"] = "KeyE";
  KeyCodeEnum["F"] = "KeyF";
  KeyCodeEnum["G"] = "KeyG";
  KeyCodeEnum["H"] = "KeyH";
  KeyCodeEnum["I"] = "KeyI";
  KeyCodeEnum["J"] = "KeyJ";
  KeyCodeEnum["K"] = "KeyK";
  KeyCodeEnum["L"] = "KeyL";
  KeyCodeEnum["M"] = "KeyM";
  KeyCodeEnum["N"] = "KeyN";
  KeyCodeEnum["O"] = "KeyO";
  KeyCodeEnum["P"] = "KeyP";
  KeyCodeEnum["Q"] = "KeyQ";
  KeyCodeEnum["R"] = "KeyR";
  KeyCodeEnum["S"] = "KeyS";
  KeyCodeEnum["T"] = "KeyT";
  KeyCodeEnum["U"] = "KeyU";
  KeyCodeEnum["V"] = "KeyV";
  KeyCodeEnum["W"] = "KeyW";
  KeyCodeEnum["X"] = "KeyX";
  KeyCodeEnum["Y"] = "KeyY";
  KeyCodeEnum["Z"] = "KeyZ";
  KeyCodeEnum["ArrowUp"] = "ArrowUp";
  KeyCodeEnum["ArrowDown"] = "ArrowDown";
  KeyCodeEnum["ArrowLeft"] = "ArrowLeft";
  KeyCodeEnum["ArrowRight"] = "ArrowRight";
})(KeyCodeEnum || (KeyCodeEnum = {}));
var KeyCodeModifiers = [KeyCodeEnum.AltLeft, KeyCodeEnum.AltRight, KeyCodeEnum.CtrlLeft, KeyCodeEnum.CtrlRight, KeyCodeEnum.ShiftLeft, KeyCodeEnum.ShiftRight, KeyCodeEnum.CommandLeft, KeyCodeEnum.CommandRight];
var KeyCodeMap = (_KeyCodeMap = {}, _defineProperty(_KeyCodeMap, KeyCodeEnum.Escape, 'esc'), _defineProperty(_KeyCodeMap, KeyCodeEnum.Tab, 'tab'), _defineProperty(_KeyCodeMap, KeyCodeEnum.AltLeft, 'alt'), _defineProperty(_KeyCodeMap, KeyCodeEnum.AltRight, 'alt'), _defineProperty(_KeyCodeMap, KeyCodeEnum.ShiftLeft, 'shift'), _defineProperty(_KeyCodeMap, KeyCodeEnum.ShiftRight, 'shift'), _defineProperty(_KeyCodeMap, KeyCodeEnum.CtrlLeft, 'ctrl'), _defineProperty(_KeyCodeMap, KeyCodeEnum.CtrlRight, 'ctrl'), _defineProperty(_KeyCodeMap, KeyCodeEnum.CommandLeft, 'meta'), _defineProperty(_KeyCodeMap, KeyCodeEnum.CommandRight, 'meta'), _defineProperty(_KeyCodeMap, KeyCodeEnum.Space, 'space'), _defineProperty(_KeyCodeMap, KeyCodeEnum.Delete, 'delete'), _defineProperty(_KeyCodeMap, KeyCodeEnum.Backspace, 'backspace'), _defineProperty(_KeyCodeMap, KeyCodeEnum.Enter, 'enter'), _defineProperty(_KeyCodeMap, KeyCodeEnum.NumpadEnter, 'enter'), _defineProperty(_KeyCodeMap, KeyCodeEnum.F1, 'f1'), _defineProperty(_KeyCodeMap, KeyCodeEnum.F2, 'f2'), _defineProperty(_KeyCodeMap, KeyCodeEnum.F3, 'f3'), _defineProperty(_KeyCodeMap, KeyCodeEnum.F4, 'f4'), _defineProperty(_KeyCodeMap, KeyCodeEnum.F5, 'f5'), _defineProperty(_KeyCodeMap, KeyCodeEnum.F6, 'f6'), _defineProperty(_KeyCodeMap, KeyCodeEnum.F7, 'f7'), _defineProperty(_KeyCodeMap, KeyCodeEnum.F8, 'f8'), _defineProperty(_KeyCodeMap, KeyCodeEnum.F9, 'f9'), _defineProperty(_KeyCodeMap, KeyCodeEnum.F10, 'f10'), _defineProperty(_KeyCodeMap, KeyCodeEnum.F11, 'f11'), _defineProperty(_KeyCodeMap, KeyCodeEnum.F12, 'f12'), _defineProperty(_KeyCodeMap, KeyCodeEnum.A, 'a'), _defineProperty(_KeyCodeMap, KeyCodeEnum.B, 'b'), _defineProperty(_KeyCodeMap, KeyCodeEnum.C, 'c'), _defineProperty(_KeyCodeMap, KeyCodeEnum.D, 'd'), _defineProperty(_KeyCodeMap, KeyCodeEnum.E, 'e'), _defineProperty(_KeyCodeMap, KeyCodeEnum.F, 'f'), _defineProperty(_KeyCodeMap, KeyCodeEnum.G, 'g'), _defineProperty(_KeyCodeMap, KeyCodeEnum.H, 'h'), _defineProperty(_KeyCodeMap, KeyCodeEnum.I, 'i'), _defineProperty(_KeyCodeMap, KeyCodeEnum.J, 'j'), _defineProperty(_KeyCodeMap, KeyCodeEnum.K, 'k'), _defineProperty(_KeyCodeMap, KeyCodeEnum.L, 'l'), _defineProperty(_KeyCodeMap, KeyCodeEnum.M, 'm'), _defineProperty(_KeyCodeMap, KeyCodeEnum.N, 'n'), _defineProperty(_KeyCodeMap, KeyCodeEnum.O, 'o'), _defineProperty(_KeyCodeMap, KeyCodeEnum.P, 'p'), _defineProperty(_KeyCodeMap, KeyCodeEnum.Q, 'q'), _defineProperty(_KeyCodeMap, KeyCodeEnum.R, 'r'), _defineProperty(_KeyCodeMap, KeyCodeEnum.S, 's'), _defineProperty(_KeyCodeMap, KeyCodeEnum.T, 't'), _defineProperty(_KeyCodeMap, KeyCodeEnum.U, 'u'), _defineProperty(_KeyCodeMap, KeyCodeEnum.V, 'v'), _defineProperty(_KeyCodeMap, KeyCodeEnum.W, 'w'), _defineProperty(_KeyCodeMap, KeyCodeEnum.X, 'x'), _defineProperty(_KeyCodeMap, KeyCodeEnum.Y, 'y'), _defineProperty(_KeyCodeMap, KeyCodeEnum.Z, 'z'), _defineProperty(_KeyCodeMap, KeyCodeEnum.ArrowUp, 'arrowup'), _defineProperty(_KeyCodeMap, KeyCodeEnum.ArrowDown, 'arrowdown'), _defineProperty(_KeyCodeMap, KeyCodeEnum.ArrowLeft, 'arrowleft'), _defineProperty(_KeyCodeMap, KeyCodeEnum.ArrowRight, 'arrowright'), _KeyCodeMap);

var DefaultOptions$1 = {
  shieldKeys: ['ctrl+s', 'ctrl+y']
};
/**
 * @description 快捷键管理
 * @description 已知问题：cmd 按下时，非修饰符按键的 up 事件不触发，eg：cmd+z，松开 z，up 事件会不触发，从而导致记录不对。
 * @description 为了让回调正确触发，只能反过来思考，如果当前组合命中了某个快捷键组合，则对其余非修饰符按键进行删除
 * @description 具体 key 的语法规则，查看 KeyCodeMap 即可，更符合语义化表达
 */
var KeyboardTrap = /*#__PURE__*/function () {
  function KeyboardTrap(options) {
    var _this = this;
    _classCallCheck(this, KeyboardTrap);
    this.handleKeydown = function (e) {
      // 如果事件源是输入组件，则忽略
      if (_this.shouldIgnore(e)) {
        return;
      }
      _this.tryToFixCommandProblem(e);
      _this.pressedKeys.add(e.code);
      var keyStr = KeyboardTrap.getHotKeyStr(Array.from(_this.pressedKeys.values()));
      var shieldKeys = _this.options.shieldKeys;
      if (shieldKeys && shieldKeys.includes(keyStr)) {
        e.stopPropagation();
        e.preventDefault();
      }
      var executed = _this.execute(keyStr, e);
      if (executed) {
        _this.pressedKeys.delete(e.code);
      }
    };
    this.handleKeyup = function (e) {
      _this.pressedKeys.delete(e.code);
    };
    /**
     * @description 当失去焦点时，再释放对应按键，此时 keyup 事件不会触发，从而导致逻辑错误，当出现时，清空列表。
     * @description 此时用户需要重新按下按键才会正常触发，但这无伤大雅，参考自 KeyboardJS
     */
    this.clearPressedSet = function () {
      _this.pressedKeys.clear();
    };
    // 因为 keydown 事件会一直触发，因此使用 set
    this.pressedKeys = new Set();
    this.handlersMap = new Map();
    this.options = merge({}, DefaultOptions$1, options || {});
    this.paused = false;
    this.addEventListeners();
  }
  _createClass(KeyboardTrap, [{
    key: "dispose",
    value: function dispose() {
      this.removeEventListeners();
    }
  }, {
    key: "bind",
    value: function bind(key, handler) {
      var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var keys = Array.isArray(key) ? key : [key];
      this.addToMapSafely(keys, handler, priority);
    }
  }, {
    key: "unbind",
    value: function unbind(key, handler) {
      var keys = Array.isArray(key) ? key : [key];
      this.removeFromMapCompletely(keys, handler);
    }
  }, {
    key: "trigger",
    value: function trigger(key) {
      this.execute(key);
    }
  }, {
    key: "pause",
    value: function pause() {
      this.paused = true;
      this.removeEventListeners();
    }
  }, {
    key: "continue",
    value: function _continue() {
      this.paused = false;
      this.addEventListeners();
    }
  }, {
    key: "reset",
    value: function reset() {
      this.handlersMap = new Map();
    }
  }, {
    key: "isPaused",
    value: function isPaused() {
      return this.paused;
    }
  }, {
    key: "isCtrlPressed",
    value: function isCtrlPressed() {
      return this.pressedKeys.has(KeyCodeEnum.CtrlLeft) || this.pressedKeys.has(KeyCodeEnum.CtrlRight);
    }
  }, {
    key: "isAltPressed",
    value: function isAltPressed() {
      return this.pressedKeys.has(KeyCodeEnum.AltLeft) || this.pressedKeys.has(KeyCodeEnum.AltRight);
    }
  }, {
    key: "isShiftPressed",
    value: function isShiftPressed() {
      return this.pressedKeys.has(KeyCodeEnum.ShiftLeft) || this.pressedKeys.has(KeyCodeEnum.ShiftRight);
    }
  }, {
    key: "isCommandPressed",
    value: function isCommandPressed() {
      return this.pressedKeys.has(KeyCodeEnum.CommandLeft) || this.pressedKeys.has(KeyCodeEnum.CommandRight);
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      document.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('keyup', this.handleKeyup);
      window.addEventListener('blur', this.clearPressedSet);
      window.addEventListener('focus', this.clearPressedSet);
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      document.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('keyup', this.handleKeyup);
      window.removeEventListener('blur', this.clearPressedSet);
      window.removeEventListener('focus', this.clearPressedSet);
    }
  }, {
    key: "addToMapSafely",
    value: function addToMapSafely(keys, handler) {
      var _this2 = this;
      var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      // trick，取巧直接挂载方法对象上
      handler.priority = priority;
      keys.forEach(function (key) {
        var handlers = _this2.handlersMap.get(key);
        if (!handlers) {
          handlers = [];
          _this2.handlersMap.set(key, handlers);
        }
        handlers.push(handler);
        // 因为执行是从后往前，因此升序排序一下
        handlers.sort(function (a, b) {
          return a.priority - b.priority;
        });
      });
    }
  }, {
    key: "removeFromMapCompletely",
    value: function removeFromMapCompletely(keys, handler) {
      var _this3 = this;
      keys.forEach(function (key) {
        // 表示相关事件全部移除
        if (!handler) {
          _this3.handlersMap.delete(key);
          return;
        }
        var handlers = _this3.handlersMap.get(key);
        if (!handlers) {
          return;
        }
        var index = handlers.indexOf(handler);
        if (index > -1) {
          handlers.splice(index, 1);
          if (!handlers.length) {
            _this3.handlersMap.delete(key);
          }
        }
      });
    }
  }, {
    key: "execute",
    value: function execute(key, e) {
      var handlers = this.handlersMap.get(key);
      if (handlers && handlers.length) {
        // 先加入的后执行，如果返回 false，则停止执行
        for (var i = handlers.length - 1; i >= 0; i -= 1) {
          var handler = handlers[i];
          // 存在上一个 handler 删除掉之后的 handler 的情况
          var shouldBubbles = handler === null || handler === void 0 ? void 0 : handler(key, e);
          if (shouldBubbles === false) {
            break;
          }
        }
        return true;
      }
      return false;
    }
  }, {
    key: "shouldIgnore",
    value: function shouldIgnore(e) {
      var _a;
      return DomUtils.isInEditableElement(e) && ((_a = e.target) === null || _a === void 0 ? void 0 : _a.getAttribute('allow-key-event')) !== 'true';
    }
    /**
     * @description 尝试解决 cmd 按键导致的问题，使影响最小
     * @description 解决思路：假设此时已经 pressedKeys 已经有 cmd+c，如果此时又按下 v，
     * @description 如果已经注册 cmd+v，则将非修饰按键删除，比如这里的 c，这样确保 cmd+v 可以触发
     * @description 有点 trick，但可以让大部分情况工作正常
     */
  }, {
    key: "tryToFixCommandProblem",
    value: function tryToFixCommandProblem(e) {
      var _this4 = this;
      var _a;
      var values = Array.from(this.pressedKeys.values());
      var modifiers = values.filter(function (item) {
        return KeyboardTrap.isModifier(item);
      });
      var notModifiers = values.filter(function (item) {
        return !KeyboardTrap.isModifier(item);
      });
      var modifiersStr = KeyboardTrap.getHotKeyStr(modifiers);
      var eventModifiers = KeyboardTrap.getEventModifiers(e);
      // 是否是修饰符按键事件，如果是，当存在对应事件处理函数时，将非修饰符列表清空
      var isModifierEvent = !!eventModifiers.length;
      var bindingKey = "".concat(modifiersStr, "+").concat(KeyboardTrap.getHotKey(e.code));
      var isExistHandler = !!((_a = this.handlersMap.get(bindingKey)) === null || _a === void 0 ? void 0 : _a.length);
      if (notModifiers.length && isModifierEvent && isExistHandler) {
        notModifiers.forEach(function (val) {
          return _this4.pressedKeys.delete(val);
        });
      }
    }
  }], [{
    key: "getHotKey",
    value: function getHotKey(keycode) {
      // 暂不区分平台，如果是 meta，直接转成 ctrl 看待
      if (keycode === KeyCodeEnum.CommandLeft || keycode === KeyCodeEnum.CommandRight) {
        return KeyCodeMap[KeyCodeEnum.CtrlLeft];
      }
      return KeyCodeMap[keycode];
    }
  }, {
    key: "getHotKeyStr",
    value: function getHotKeyStr(keyCodes) {
      var hotkeys = [];
      for (var i = 0; i < keyCodes.length; i += 1) {
        var value = keyCodes[i];
        var hotKey = KeyboardTrap.getHotKey(value);
        if (!hotKey) {
          continue;
        }
        hotkeys.push(hotKey);
      }
      return hotkeys.join('+');
    }
  }, {
    key: "isModifier",
    value: function isModifier(keyCode) {
      return KeyCodeModifiers.includes(keyCode);
    }
  }, {
    key: "getEventModifiers",
    value: function getEventModifiers(e) {
      var modifiers = [];
      if (e.shiftKey) {
        modifiers.push('shift');
      }
      if (e.altKey) {
        modifiers.push('alt');
      }
      if (e.ctrlKey) {
        modifiers.push('ctrl');
      }
      if (e.metaKey) {
        modifiers.push('meta');
      }
      return modifiers;
    }
  }]);
  return KeyboardTrap;
}();

var MatchUtils = /*#__PURE__*/function () {
  function MatchUtils() {
    _classCallCheck(this, MatchUtils);
  }
  _createClass(MatchUtils, null, [{
    key: "isValidPhone",
    value: function isValidPhone(phone) {
      var regex = /^1(3\d|4[5-9]|5[0-35-9]|6[25-7]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
      return phone ? regex.test(phone.toString()) : false;
    }
  }]);
  return MatchUtils;
}();

var REQUEST_ERROR_NOTIFICATION_KEY = 'REQUEST_ERROR_NOTIFICATION_KEY';
var REQUEST_LOADING_MESSAGE_KEY = 'REQUEST_LOADING_MESSAGE_KEY';
var JWT_HEADER_NAME = 'XAuthorization';
var CancelTypeEnum;
(function (CancelTypeEnum) {
  CancelTypeEnum["CANCEL"] = "CANCEL";
  CancelTypeEnum["CANCEL_WITH_LOADING"] = "CANCEL_WITH_LOADING";
})(CancelTypeEnum || (CancelTypeEnum = {}));
var CodeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '请先登录。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  413: '请求发送的资源大小超过服务器限制',
  422: '当创建一个对象时，发生一个验证错误。',
  429: '操作过于频繁，请稍后再试',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。'
};

var CustomError = /*#__PURE__*/_createClass(function CustomError(response) {
  _classCallCheck(this, CustomError);
  this.type = 'custom';
  this.response = response;
  this.status = response.data.status;
  this.message = response.data.message;
});

function isDefined(obj) {
  return typeof obj !== 'undefined';
}
function isWrappedApi(response) {
  var data = response.data;
  return isDefined(data === null || data === void 0 ? void 0 : data.message) && isDefined(data === null || data === void 0 ? void 0 : data.status);
}
function isCustomError(error) {
  return error instanceof CustomError;
}
function parseUrlWithUrlParams(url, params) {
  var parsedUrl = url;
  var keys = Object.keys(params);
  keys.forEach(function (key) {
    var reg = new RegExp(":".concat(key), 'g');
    parsedUrl = parsedUrl.replace(reg, params[key]);
  });
  return parsedUrl;
}
var stage = process.env.REACT_APP_STAGE || 'local';
var isLocalEnvironment = stage.startsWith('local');

var StyleTransform = /*#__PURE__*/function () {
  function StyleTransform() {
    _classCallCheck(this, StyleTransform);
  }
  _createClass(StyleTransform, null, [{
    key: "camelCaseToSnakeCase",
    value: function camelCaseToSnakeCase(s) {
      return s.replace(/^_+/g, '_').replace(/_+$/g, '').replace(/(_+)/g, '_').replace(/^([A-Z])/, function (m, p1) {
        return "".concat(p1.toLowerCase());
      }).replace(/V(\d+)/g, function (m, p1) {
        return "_v".concat(p1);
      }).replace(/(\d+)([A-Z]+)/g, function (m, p1, p2) {
        return "_".concat(p1, "_").concat(p2.toLowerCase());
      }).replace(/([a-z])([A-Z]+)/g, function (m, p1, p2) {
        return "".concat(p1, "_").concat(p2.toLowerCase());
      }).replace(/([A-Z]+)/g, function (m, p1) {
        return "".concat(p1.toLowerCase());
      });
    }
  }, {
    key: "snakeCaseToCamelCase",
    value: function snakeCaseToCamelCase(s) {
      return s.replace(/^_+(\w)/g, function (m, p1) {
        return "_".concat(p1.toLowerCase());
      })
      // FIXME: safari didn't support lookbehind assertions ((?<= ) and (?<! ))
      .replace(/(?<!^)_+(\w)/g, function (m, p1) {
        return p1.toUpperCase();
      }).replace(/^([A-Z])/, function (m, p1) {
        return "".concat(p1.toLowerCase());
      }).replace(/_+$/, '');
    }
  }, {
    key: "convertKeysToCamelCase",
    value: function convertKeysToCamelCase(o) {
      if (TypeUtils.isArray(o)) {
        // 如果数组元素是简单类型的则默认不需要遍历
        if (o.length > 0 && !TypeUtils.isArray(o[0]) && !TypeUtils.isObject(o[0])) {
          return o;
        }
        return o.map(function (item) {
          return StyleTransform.convertKeysToCamelCase(item);
        });
      }
      if (TypeUtils.isObject(o)) {
        var result = {};
        Object.keys(o).forEach(function (key) {
          // @ts-ignore
          result[StyleTransform.snakeCaseToCamelCase(key)] = StyleTransform.convertKeysToCamelCase(o[key]);
        });
        return result;
      }
      return o;
    }
  }, {
    key: "convertKeysToSnakeCase",
    value: function convertKeysToSnakeCase(o) {
      if (TypeUtils.isArray(o)) {
        // 如果数组元素是简单类型的则默认不需要遍历
        if (o.length > 0 && !TypeUtils.isArray(o[0]) && !TypeUtils.isObject(o[0])) {
          return o;
        }
        return o.map(function (item) {
          return StyleTransform.convertKeysToSnakeCase(item);
        });
      }
      if (TypeUtils.isObject(o)) {
        var result = {};
        Object.keys(o).forEach(function (key) {
          // @ts-ignore
          result[StyleTransform.camelCaseToSnakeCase(key)] = StyleTransform.convertKeysToSnakeCase(o[key]);
        });
        return result;
      }
      return o;
    }
  }]);
  return StyleTransform;
}();

function styleTransformReqInterceptor(config) {
  config.params = StyleTransform.convertKeysToSnakeCase(config.params);
  if (!(config.data instanceof FormData)) {
    config.data = StyleTransform.convertKeysToSnakeCase(config.data);
  }
  return config;
}
function styleTransformResInterceptor(response) {
  if (!response.config.responseType || response.config.responseType === 'json') {
    response.data = StyleTransform.convertKeysToCamelCase(response.data);
  }
  return response;
}
function authHeaderReqInterceptor(config) {
  var fullUrl = new URL(UrlUtils.getFullRequestUrl(config.url || ''));
  // 避免 token 给第三方，仅允许本地开发附加 token
  var isSameOrigin = process.env.NODE_ENV === 'development' ? true : fullUrl.origin === window.location.origin;
  // jwt token --- pay attention here, here is hard code!!!
  var token = localStorage.getItem('fish');
  if (token && isSameOrigin) {
    config.headers = Object.assign(Object.assign({}, config.headers), _defineProperty({}, JWT_HEADER_NAME, "Bearer ".concat(token)));
  }
  return config;
}
var needLoadingRequestCount = 0;
var hideMessage;
function showLoading() {
  hideMessage = Message.loading({
    content: '加载中',
    duration: 0,
    id: REQUEST_LOADING_MESSAGE_KEY
  });
  needLoadingRequestCount += 1;
}
function hideLoading() {
  needLoadingRequestCount -= 1;
  needLoadingRequestCount = Math.max(needLoadingRequestCount, 0);
  if (needLoadingRequestCount === 0 && hideMessage) {
    hideMessage();
  }
}
function loadingReqInterceptor(config) {
  if (config.loading) {
    showLoading();
  }
  return config;
}
function loadingResInterceptor(res) {
  if (res.config.loading) {
    hideLoading();
  }
  return res;
}
function loadingResInterceptorError(error) {
  var _a;
  if (((_a = error === null || error === void 0 ? void 0 : error.config) === null || _a === void 0 ? void 0 : _a.loading) || (error === null || error === void 0 ? void 0 : error.message) === CancelTypeEnum.CANCEL_WITH_LOADING) {
    hideLoading();
  }
  return Promise.reject(error);
}
function parseResponseInterceptor(response) {
  var _a;
  var resolvedData = isWrappedApi(response) ? (_a = response.data) === null || _a === void 0 ? void 0 : _a.data : response.data;
  if (response.config.getResponse) {
    response.data = resolvedData;
    return response;
  }
  if (response.config.getFullData) {
    return response.data;
  }
  return resolvedData;
}
function throwCustomErrorResInterceptor(response) {
  if (isWrappedApi(response)) {
    var data = response.data;
    if (data.message !== 'success') {
      return Promise.reject(new CustomError(response));
    }
  }
  return response;
}
function showErrorNotification(title, content) {
  Notification.error({
    id: REQUEST_ERROR_NOTIFICATION_KEY,
    title: title,
    content: content
  });
}
function errorHandler(error) {
  var _a, _b, _c, _d;
  if (axios.isCustomError(error)) {
    if (!error.response.config.skipErrorHandler) {
      showErrorNotification('请求错误', error.message);
    }
    return Promise.reject(error);
  }
  // 走到这里表示是 HTTP 状态码非 2xx 导致的错误
  var buildInError = error;
  var response = buildInError.response;
  if (response) {
    // 字段驼峰处理
    if (response.data) {
      response.data = StyleTransform.convertKeysToCamelCase(response.data);
    }
    var errorText = ((_a = response.data) === null || _a === void 0 ? void 0 : _a.errorMessage) || ((_b = response.data) === null || _b === void 0 ? void 0 : _b.message) ||
    // @ts-ignore
    CodeMessage[response.status] || response.statusText;
    if (!((_c = buildInError.config) === null || _c === void 0 ? void 0 : _c.skipErrorHandler)) {
      showErrorNotification('请求错误', errorText);
    }
    if (response.status === 401) ;
  } else if (!axios.isCancel(buildInError) && !((_d = buildInError.config) === null || _d === void 0 ? void 0 : _d.skipErrorHandler)) {
    showErrorNotification('网络异常', '您的网络发生异常，无法连接服务器');
  }
  return Promise.reject(buildInError);
}

var RequestFactory = /*#__PURE__*/function () {
  function RequestFactory() {
    _classCallCheck(this, RequestFactory);
    this.requestInstanceMap = new Map();
    this.onCreateCallbacks = [];
  }
  _createClass(RequestFactory, [{
    key: "create",
    value: function create(key, baseURL) {
      if (this.requestInstanceMap.has(key)) {
        return this.requestInstanceMap.get(key);
      }
      var config = {};
      if (typeof baseURL === 'string') {
        config = {
          baseURL: baseURL
        };
      } else {
        config = baseURL;
      }
      var instance = axios.create(config);
      this.requestInstanceMap.set(key, instance);
      // 配置 loading 功能
      instance.interceptors.request.use(loadingReqInterceptor);
      instance.interceptors.response.use(loadingResInterceptor, loadingResInterceptorError);
      // 配置认证请求头
      instance.interceptors.request.use(authHeaderReqInterceptor);
      // 配置风格转换
      instance.interceptors.request.use(styleTransformReqInterceptor);
      instance.interceptors.response.use(styleTransformResInterceptor);
      // 默认错误处理
      instance.interceptors.response.use(throwCustomErrorResInterceptor);
      instance.interceptors.response.use(undefined, errorHandler);
      // 配置是否需要简化 response，涉及到 response 的修改，因此顺序很关键，放最后
      instance.interceptors.response.use(parseResponseInterceptor);
      // emit event
      this.onCreateCallbacks.forEach(function (callback) {
        return callback();
      });
      return instance;
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.requestInstanceMap.get(key);
    }
  }, {
    key: "keys",
    value: function keys() {
      return Array.from(this.requestInstanceMap.keys());
    }
  }, {
    key: "addOnCreate",
    value: function addOnCreate(callback) {
      this.onCreateCallbacks.push(callback);
    }
  }, {
    key: "removeOnCreate",
    value: function removeOnCreate(callback) {
      var index = this.onCreateCallbacks.findIndex(callback);
      this.onCreateCallbacks.splice(index, 1);
    }
  }]);
  return RequestFactory;
}();
var requestFactory = new RequestFactory();
var requestFactory$1 = requestFactory;

/* eslint-disable no-console */
var isDev = process.env.NODE_ENV === 'development';
var LogUtils = /*#__PURE__*/function () {
  function LogUtils() {
    _classCallCheck(this, LogUtils);
  }
  _createClass(LogUtils, null, [{
    key: "log",
    value: function log(message) {
      if (isDev) {
        console.log(message);
      }
    }
  }, {
    key: "error",
    value: function error(_error) {
      if (isDev) {
        console.error(_error);
      }
    }
  }, {
    key: "warn",
    value: function warn(message) {
      if (isDev) {
        console.warn(message);
      }
    }
  }]);
  return LogUtils;
}();

var DisconnectReasonEnum;
(function (DisconnectReasonEnum) {
  DisconnectReasonEnum["IO_SERVER_DISCONNECT"] = "io server disconnect";
  DisconnectReasonEnum["IO_CLIENT_DISCONNECT"] = "io client disconnect";
  DisconnectReasonEnum["PING_TIMEOUT"] = "ping timeout";
  DisconnectReasonEnum["TRANSPORT_CLOSE"] = "transport close";
  DisconnectReasonEnum["TRANSPORT_ERROR"] = "transport error";
})(DisconnectReasonEnum || (DisconnectReasonEnum = {}));
function convertToException(exception) {
  return StyleTransform.convertKeysToCamelCase(exception);
}
var SocketWrapper = /*#__PURE__*/function () {
  function SocketWrapper(socketUrl) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, SocketWrapper);
    this.shouldUpdateWhenConnected = false;
    var _options$autoConnect = options.autoConnect,
      autoConnect = _options$autoConnect === void 0 ? false : _options$autoConnect,
      transports = options.transports,
      _options$skipErrorHan = options.skipErrorHandler,
      skipErrorHandler = _options$skipErrorHan === void 0 ? false : _options$skipErrorHan,
      _options$autoConnectW = options.autoConnectWhenSending,
      autoConnectWhenSending = _options$autoConnectW === void 0 ? true : _options$autoConnectW;
    this.options = {
      autoConnect: autoConnect,
      transports: transports,
      skipErrorHandler: skipErrorHandler,
      autoConnectWhenSending: autoConnectWhenSending
    };
    var socketOptions = {
      autoConnect: autoConnect,
      transports: transports
    };
    this.socket = io(socketUrl, socketOptions);
    this.isMounted = false;
    this.endRun = new Set();
    this.init();
  }
  _createClass(SocketWrapper, [{
    key: "unmount",
    value: function unmount() {
      this.isMounted = false;
      this.disconnect();
    }
  }, {
    key: "connect",
    value: function connect() {
      if (this.socket.disconnected) {
        this.socket.connect();
      }
    }
  }, {
    key: "emit",
    value: function emit(ev) {
      var _this = this;
      if (!this.isMounted) {
        return Promise.resolve();
      }
      if (this.options.autoConnectWhenSending) {
        this.connect();
      }
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      var transformedArgs = args.map(function (arg) {
        if (arg instanceof Blob || arg instanceof ArrayBuffer) {
          return arg;
        }
        return StyleTransform.convertKeysToSnakeCase(arg);
      });
      return new Promise(function (resolve, reject) {
        transformedArgs.push(function (data) {
          resolve(data);
        });
        try {
          var _this$socket;
          (_this$socket = _this.socket).emit.apply(_this$socket, [ev].concat(_toConsumableArray(transformedArgs)));
        } catch (_a) {
          reject();
        }
      });
    }
  }, {
    key: "on",
    value: function on(ev, listener) {
      this.socket.on(ev, listener);
    }
  }, {
    key: "off",
    value: function off(ev, listener) {
      this.socket.off(ev, listener);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      if (this.socket.connected) {
        this.socket.disconnect();
      }
    }
    /**
     * @description 开启监听具体，这是一个 React hooks，需遵守 hooks 使用规则
     * @param eventName 事件名称
     * @param options 可以直接传处理 message 的回调，也可以直接传递对象，通过 onMessage、onException、onError 处理更多逻辑
     */
  }, {
    key: "useSubscription",
    value: function useSubscription(eventName, options) {
      var _this2 = this;
      var finalOptions = options;
      if (typeof options === 'function') {
        finalOptions = {
          onMessage: options
        };
      }
      var latestOptions = useLatest(finalOptions);
      useEffect(function () {
        var handleMessage = function handleMessage() {
          var _latestOptions$curren;
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }
          var transformedArgs = args.map(function (arg) {
            if (arg instanceof Blob || arg instanceof ArrayBuffer) {
              return arg;
            }
            return StyleTransform.convertKeysToCamelCase(arg);
          });
          (_latestOptions$curren = latestOptions.current).onMessage.apply(_latestOptions$curren, _toConsumableArray(transformedArgs));
        };
        var handleEnd = function handleEnd() {
          if (latestOptions.current.onEnd) {
            latestOptions.current.onEnd();
          }
        };
        var handleException = function handleException(error) {
          var exception = convertToException(error);
          if (exception.fromEvent === eventName && latestOptions.current.onException) {
            latestOptions.current.onException(exception);
          }
        };
        _this2.on(eventName, handleMessage);
        _this2.on('exception', handleException);
        _this2.endRun.add(handleEnd);
        return function () {
          _this2.off(eventName, handleMessage);
          _this2.off('exception', handleException);
          _this2.endRun.delete(handleEnd);
        };
      }, [eventName, latestOptions]);
    }
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;
      this.isMounted = true;
      this.socket.on('connect', function () {
        if (_this3.shouldUpdateWhenConnected) {
          _this3.shouldUpdateWhenConnected = false;
          Notification.success({
            id: REQUEST_ERROR_NOTIFICATION_KEY,
            title: '服务提示',
            content: '服务重连成功！'
          });
        }
      });
      this.socket.on('disconnect', function (reason) {
        LogUtils.log(reason);
        // 后面两种方式会触发自动重连，暂忽略。服务端或客户端手动关闭，认为已经完成
        if (reason === DisconnectReasonEnum.IO_CLIENT_DISCONNECT || reason === DisconnectReasonEnum.IO_SERVER_DISCONNECT) {
          _this3.endRun.forEach(function (end) {
            return end();
          });
        } else {
          _this3.shouldUpdateWhenConnected = true;
          _this3.showReconnectingNotification();
        }
      });
      this.socket.on('connect_error', function (error) {
        // 当连接状态断网时，会触发 disconnect 事件，然后自动重连，接着反复触发 connect_error
        // 当断网状态时，点击连接，连接失败，然后自动重连，接着反复触发 connect_error
        LogUtils.error(error);
        _this3.shouldUpdateWhenConnected = true;
        _this3.showReconnectingNotification();
      });
      var handleException = function handleException(error) {
        var exception = convertToException(error);
        if (!_this3.options.skipErrorHandler) {
          Notification.error({
            id: REQUEST_ERROR_NOTIFICATION_KEY,
            title: '请求错误',
            content: exception.message
          });
        }
      };
      // 内置异常处理器
      this.socket.on('exception', handleException);
    }
  }, {
    key: "showReconnectingNotification",
    value: function showReconnectingNotification() {
      Notification.error({
        id: REQUEST_ERROR_NOTIFICATION_KEY,
        title: '服务异常',
        content: '服务断开连接，正在重连，请稍候……',
        closable: false,
        duration: 0
      });
    }
  }]);
  return SocketWrapper;
}();

/**
 * @description 目标：更安全的使用 socket，避免创建多次连接、或忘记关闭连接
 * @description 目标：更容易写出正确的代码，React hooks 由于闭包问题导致代码错误、数据风格转换、服务端错误处理
 * @param socketUrl
 * @param options
 * @returns 相关 api 对象
 */
function useSocket(socketUrl, options) {
  var socketWrapper = useCreation(function () {
    return new SocketWrapper(socketUrl, options);
  }, []);
  // 组件卸载时，断开链接
  useUnmount(function () {
    socketWrapper.unmount();
  });
  return socketWrapper;
}

// extend
axios.isCustomError = isCustomError;
var index = 0;
function create(baseURL, name) {
  index += 1;
  var key = name || "default".concat(index);
  return requestFactory$1.create(key, baseURL);
}
var request = {
  create: create
};
var request$1 = request;

var Snapshot = /*#__PURE__*/function () {
  function Snapshot(data) {
    _classCallCheck(this, Snapshot);
    this.data = data;
  }
  _createClass(Snapshot, [{
    key: "get",
    value: function get() {
      return this.data;
    }
  }]);
  return Snapshot;
}();

/**
 * @description 两种思路
 * 思路 A：新增操作时，将新增前的状态存储栈中，这存在的问题是，
 * current 值存储在调用方，但内部执行 undo/redo 时又需要，跟踪正确的 current 不容易，导致不太好设计 api。
 * 思路 B：新增操作时，将新增后的状态存储栈中，但这存在的问题是，
 * 最初始的状态无法还原，只能还原到第一步，因此考虑该类构造时需要提供一个初始状态参数
 * @author Ethan
 * @class SnapshotHolder
 * @template T
 */
var SnapshotHolder = /*#__PURE__*/function () {
  function SnapshotHolder(initialState) {
    _classCallCheck(this, SnapshotHolder);
    this.rebuild(initialState);
  }
  _createClass(SnapshotHolder, [{
    key: "canUndo",
    get: function get() {
      return !!this.stack[this.step - 1];
    }
  }, {
    key: "canRedo",
    get: function get() {
      return !!this.stack[this.step + 1];
    }
  }, {
    key: "undo",
    value: function undo() {
      if (this.step === 0) {
        return null;
      }
      this.step -= 1;
      return this.stack[this.step];
    }
  }, {
    key: "redo",
    value: function redo() {
      if (this.step === this.stack.length - 1) {
        return null;
      }
      this.step += 1;
      return this.stack[this.step];
    }
  }, {
    key: "rebuild",
    value: function rebuild(initialState) {
      this.stack = [initialState];
      this.step = 0;
    }
  }, {
    key: "pushSnapshot",
    value: function pushSnapshot(snapshot) {
      this.stack = this.stack.slice(0, this.step + 1);
      this.stack.push(snapshot);
      this.step += 1;
    }
  }]);
  return SnapshotHolder;
}();

var TaskStatusEnum;
(function (TaskStatusEnum) {
  TaskStatusEnum["NOT_READY"] = "not_ready";
  TaskStatusEnum["QUEUE"] = "queue";
  TaskStatusEnum["EXECUTING"] = "executing";
  TaskStatusEnum["CANCEL"] = "cancel";
  TaskStatusEnum["ERROR"] = "error";
  TaskStatusEnum["SUCCESS"] = "success";
})(TaskStatusEnum || (TaskStatusEnum = {}));

function isComplete(task) {
  var completeTags = [TaskStatusEnum.CANCEL, TaskStatusEnum.ERROR, TaskStatusEnum.SUCCESS];
  return completeTags.includes(task.status);
}

var DefaultOptions = {
  host: '/api',
  queryTasks: '/v1/misc/tasks',
  deleteTask: '/v1/misc/tasks/:taskId',
  queryTaskGroups: '/v1/misc/task-groups',
  deleteTaskGroup: '/v1/misc/task-groups/:taskGroupId',
  deleteTaskGroups: '/v1/misc/task-groups',
  interval: 5000
};
/**
 * @deprecated 相关接口后端已删
 */
var TaskSystem = /*#__PURE__*/function () {
  function TaskSystem(subscribe) {
    _classCallCheck(this, TaskSystem);
    this.state = {
      tasks: [],
      cancelingTask: false,
      cancelingTaskGroup: false,
      isReady: false
    };
    this.subscribe = subscribe;
    var noop = function noop() {};
    this.subscription = {
      onComplete: noop,
      onAllComplete: noop
    };
  }
  _createClass(TaskSystem, [{
    key: "useSubscribe",
    value: function useSubscribe(projId, subscription) {
      var _this = this;
      this.subscription = Object.assign(Object.assign({}, this.subscription), subscription);
      useMount(function () {
        TaskSystem.queryTaskGroups({
          projId: projId,
          wip: true
        }).then(function (groups) {
          var tasks = groups.flatMap(function (item) {
            return item.tasks;
          }).filter(function (item) {
            return !isComplete(item);
          });
          _this.setState({
            tasks: tasks
          });
          _this.startQueryIfNeed();
          _this.setState({
            isReady: true
          });
        });
      });
    }
  }, {
    key: "cancelTaskGroup",
    value: function cancelTaskGroup(taskGroup) {
      var _this2 = this;
      var taskGroupId = typeof taskGroup === 'string' ? taskGroup : taskGroup.id;
      this.setState({
        cancelingTaskGroup: true
      });
      return TaskSystem.deleteTaskGroup(taskGroupId).then(function () {
        var tasks = _this2.state.tasks.filter(function (item) {
          return item.taskGroupId !== taskGroupId;
        });
        _this2.setState({
          tasks: tasks
        });
        _this2.endQueryIfNeed();
      }).finally(function () {
        _this2.setState({
          cancelingTaskGroup: false
        });
      });
    }
  }, {
    key: "cancelTask",
    value: function cancelTask(task) {
      var _this3 = this;
      var taskId = typeof task === 'string' ? task : task.id;
      this.setState({
        cancelingTask: true
      });
      return TaskSystem.deleteTask(taskId).then(function () {
        var index = _this3.state.tasks.findIndex(function (item) {
          return item.id === taskId;
        });
        if (index !== -1) {
          var tasks = _this3.state.tasks.slice().splice(index, 1);
          _this3.setState({
            tasks: tasks
          });
          _this3.endQueryIfNeed();
        }
      }).finally(function () {
        _this3.setState({
          cancelingTask: false
        });
      });
    }
  }, {
    key: "cancelAll",
    value: function cancelAll() {
      var _this4 = this;
      this.setState({
        cancelingTaskGroup: true
      });
      var allIds = Array.from(new Set(this.state.tasks.map(function (item) {
        return item.taskGroupId;
      })));
      return TaskSystem.deleteTaskGroups(allIds).then(function () {
        _this4.setState({
          tasks: []
        });
      }).finally(function () {
        _this4.setState({
          cancelingTaskGroup: false
        });
      });
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.state.tasks.length === 0;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.clearIntervalIfNeed();
    }
  }, {
    key: "setState",
    value: function setState() {
      var partialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.state = Object.assign(Object.assign({}, this.state), partialState);
      this.subscribe();
    }
  }, {
    key: "startQueryIfNeed",
    value: function startQueryIfNeed() {
      var _this5 = this;
      // 如果存在未完成的任务且未开启轮询
      if (this.state.tasks.length && !this.intervalId) {
        this.intervalId = window.setInterval(function () {
          TaskSystem.queryTasks(_this5.state.tasks.map(function (item) {
            return item.id;
          })).then(function (data) {
            var completeTasks = data.filter(function (item) {
              return isComplete(item);
            });
            if (completeTasks.length) {
              _this5.subscription.onComplete(completeTasks);
              // 从队列中移除已完成
              var tasks = _this5.state.tasks.filter(function (item) {
                return !completeTasks.some(function (inner) {
                  return inner.id === item.id;
                });
              });
              _this5.setState({
                tasks: tasks
              });
              _this5.endQueryIfNeed();
            }
          });
        }, TaskSystem.options.interval);
      }
    }
  }, {
    key: "endQueryIfNeed",
    value: function endQueryIfNeed() {
      // 如果列表为空且正在轮询，则关闭
      if (!this.state.tasks.length) {
        this.clearIntervalIfNeed();
        this.subscription.onAllComplete();
      }
    }
  }, {
    key: "clearIntervalIfNeed",
    value: function clearIntervalIfNeed() {
      if (this.intervalId) {
        window.clearInterval(this.intervalId);
        this.intervalId = undefined;
      }
    }
  }], [{
    key: "init",
    value: function init(options) {
      this.options = Object.assign(Object.assign({}, DefaultOptions), options);
      this.instance = request$1.create(this.options.host);
    }
  }, {
    key: "queryTaskGroups",
    value: function queryTaskGroups(params) {
      return this.instance.get(this.options.queryTaskGroups, {
        params: params
      });
    }
  }, {
    key: "queryTasks",
    value: function queryTasks(taskIds) {
      // axios 封装后 GET 无法通过请求体传数据，考虑到 taskIds 数据量可能比较大，降级使用语义不那么合适的 POST
      return this.instance.post(this.options.queryTasks, taskIds);
    }
  }, {
    key: "deleteTaskGroup",
    value: function deleteTaskGroup(taskGroupId) {
      var url = parseUrlWithUrlParams(this.options.deleteTaskGroup, {
        taskGroupId: taskGroupId
      });
      return this.instance.delete(url);
    }
  }, {
    key: "deleteTaskGroups",
    value: function deleteTaskGroups(taskGroupIds) {
      return this.instance.request({
        method: 'delete',
        url: this.options.deleteTaskGroups,
        data: taskGroupIds
      });
    }
  }, {
    key: "deleteTask",
    value: function deleteTask(taskId) {
      var url = parseUrlWithUrlParams(this.options.deleteTask, {
        taskId: taskId
      });
      return this.instance.delete(url);
    }
  }]);
  return TaskSystem;
}();

function useTaskSystem() {
  var update = useUpdate();
  var taskSystem = useCreation(function () {
    return new TaskSystem(update);
  }, []);
  useUnmount(function () {
    taskSystem.destroy();
  });
  return taskSystem;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var dayjs_min$1 = {exports: {}};

(function (module, exports) {
  !function (t, e) {
    module.exports = e() ;
  }(commonjsGlobal, function () {

    var t = 1e3,
      e = 6e4,
      n = 36e5,
      r = "millisecond",
      i = "second",
      s = "minute",
      u = "hour",
      a = "day",
      o = "week",
      c = "month",
      f = "quarter",
      h = "year",
      d = "date",
      l = "Invalid Date",
      $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
      y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
      M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function ordinal(t) {
          var e = ["th", "st", "nd", "rd"],
            n = t % 100;
          return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
      },
      m = function m(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
      },
      v = {
        s: m,
        z: function z(t) {
          var e = -t.utcOffset(),
            n = Math.abs(e),
            r = Math.floor(n / 60),
            i = n % 60;
          return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
          if (e.date() < n.date()) return -t(n, e);
          var r = 12 * (n.year() - e.year()) + (n.month() - e.month()),
            i = e.clone().add(r, c),
            s = n - i < 0,
            u = e.clone().add(r + (s ? -1 : 1), c);
          return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function a(t) {
          return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function p(t) {
          return {
            M: c,
            y: h,
            w: o,
            d: a,
            D: d,
            h: u,
            m: s,
            s: i,
            ms: r,
            Q: f
          }[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function u(t) {
          return void 0 === t;
        }
      },
      g = "en",
      D = {};
    D[g] = M;
    var p = function p(t) {
        return t instanceof b;
      },
      S = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
          var s = e.toLowerCase();
          D[s] && (i = s), n && (D[s] = n, i = s);
          var u = e.split("-");
          if (!i && u.length > 1) return t(u[0]);
        } else {
          var a = e.name;
          D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
      },
      w = function w(t, e) {
        if (p(t)) return t.clone();
        var n = "object" == _typeof(e) ? e : {};
        return n.date = t, n.args = arguments, new b(n);
      },
      O = v;
    O.l = S, O.i = p, O.w = function (t, e) {
      return w(t, {
        locale: e.$L,
        utc: e.$u,
        x: e.$x,
        $offset: e.$offset
      });
    };
    var b = function () {
        function M(t) {
          this.$L = S(t.locale, null, !0), this.parse(t);
        }
        var m = M.prototype;
        return m.parse = function (t) {
          this.$d = function (t) {
            var e = t.date,
              n = t.utc;
            if (null === e) return new Date(NaN);
            if (O.u(e)) return new Date();
            if (e instanceof Date) return new Date(e);
            if ("string" == typeof e && !/Z$/i.test(e)) {
              var r = e.match($);
              if (r) {
                var i = r[2] - 1 || 0,
                  s = (r[7] || "0").substring(0, 3);
                return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
              }
            }
            return new Date(e);
          }(t), this.$x = t.x || {}, this.init();
        }, m.init = function () {
          var t = this.$d;
          this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function () {
          return O;
        }, m.isValid = function () {
          return !(this.$d.toString() === l);
        }, m.isSame = function (t, e) {
          var n = w(t);
          return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function (t, e) {
          return w(t) < this.startOf(e);
        }, m.isBefore = function (t, e) {
          return this.endOf(e) < w(t);
        }, m.$g = function (t, e, n) {
          return O.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function () {
          return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function () {
          return this.$d.getTime();
        }, m.startOf = function (t, e) {
          var n = this,
            r = !!O.u(e) || e,
            f = O.p(t),
            l = function l(t, e) {
              var i = O.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
              return r ? i : i.endOf(a);
            },
            $ = function $(t, e) {
              return O.w(n.toDate()[t].apply(n.toDate("s"), (r ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e)), n);
            },
            y = this.$W,
            M = this.$M,
            m = this.$D,
            v = "set" + (this.$u ? "UTC" : "");
          switch (f) {
            case h:
              return r ? l(1, 0) : l(31, 11);
            case c:
              return r ? l(1, M) : l(0, M + 1);
            case o:
              var g = this.$locale().weekStart || 0,
                D = (y < g ? y + 7 : y) - g;
              return l(r ? m - D : m + (6 - D), M);
            case a:
            case d:
              return $(v + "Hours", 0);
            case u:
              return $(v + "Minutes", 1);
            case s:
              return $(v + "Seconds", 2);
            case i:
              return $(v + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, m.endOf = function (t) {
          return this.startOf(t, !1);
        }, m.$set = function (t, e) {
          var n,
            o = O.p(t),
            f = "set" + (this.$u ? "UTC" : ""),
            l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o],
            $ = o === a ? this.$D + (e - this.$W) : e;
          if (o === c || o === h) {
            var y = this.clone().set(d, 1);
            y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
          } else l && this.$d[l]($);
          return this.init(), this;
        }, m.set = function (t, e) {
          return this.clone().$set(t, e);
        }, m.get = function (t) {
          return this[O.p(t)]();
        }, m.add = function (r, f) {
          var d,
            l = this;
          r = Number(r);
          var $ = O.p(f),
            y = function y(t) {
              var e = w(l);
              return O.w(e.date(e.date() + Math.round(t * r)), l);
            };
          if ($ === c) return this.set(c, this.$M + r);
          if ($ === h) return this.set(h, this.$y + r);
          if ($ === a) return y(1);
          if ($ === o) return y(7);
          var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1,
            m = this.$d.getTime() + r * M;
          return O.w(m, this);
        }, m.subtract = function (t, e) {
          return this.add(-1 * t, e);
        }, m.format = function (t) {
          var e = this,
            n = this.$locale();
          if (!this.isValid()) return n.invalidDate || l;
          var r = t || "YYYY-MM-DDTHH:mm:ssZ",
            i = O.z(this),
            s = this.$H,
            u = this.$m,
            a = this.$M,
            o = n.weekdays,
            c = n.months,
            f = n.meridiem,
            h = function h(t, n, i, s) {
              return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            },
            d = function d(t) {
              return O.s(s % 12 || 12, t, "0");
            },
            $ = f || function (t, e, n) {
              var r = t < 12 ? "AM" : "PM";
              return n ? r.toLowerCase() : r;
            };
          return r.replace(y, function (t, r) {
            return r || function (t) {
              switch (t) {
                case "YY":
                  return String(e.$y).slice(-2);
                case "YYYY":
                  return O.s(e.$y, 4, "0");
                case "M":
                  return a + 1;
                case "MM":
                  return O.s(a + 1, 2, "0");
                case "MMM":
                  return h(n.monthsShort, a, c, 3);
                case "MMMM":
                  return h(c, a);
                case "D":
                  return e.$D;
                case "DD":
                  return O.s(e.$D, 2, "0");
                case "d":
                  return String(e.$W);
                case "dd":
                  return h(n.weekdaysMin, e.$W, o, 2);
                case "ddd":
                  return h(n.weekdaysShort, e.$W, o, 3);
                case "dddd":
                  return o[e.$W];
                case "H":
                  return String(s);
                case "HH":
                  return O.s(s, 2, "0");
                case "h":
                  return d(1);
                case "hh":
                  return d(2);
                case "a":
                  return $(s, u, !0);
                case "A":
                  return $(s, u, !1);
                case "m":
                  return String(u);
                case "mm":
                  return O.s(u, 2, "0");
                case "s":
                  return String(e.$s);
                case "ss":
                  return O.s(e.$s, 2, "0");
                case "SSS":
                  return O.s(e.$ms, 3, "0");
                case "Z":
                  return i;
              }
              return null;
            }(t) || i.replace(":", "");
          });
        }, m.utcOffset = function () {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function (r, d, l) {
          var $,
            y = this,
            M = O.p(d),
            m = w(r),
            v = (m.utcOffset() - this.utcOffset()) * e,
            g = this - m,
            D = function D() {
              return O.m(y, m);
            };
          switch (M) {
            case h:
              $ = D() / 12;
              break;
            case c:
              $ = D();
              break;
            case f:
              $ = D() / 3;
              break;
            case o:
              $ = (g - v) / 6048e5;
              break;
            case a:
              $ = (g - v) / 864e5;
              break;
            case u:
              $ = g / n;
              break;
            case s:
              $ = g / e;
              break;
            case i:
              $ = g / t;
              break;
            default:
              $ = g;
          }
          return l ? $ : O.a($);
        }, m.daysInMonth = function () {
          return this.endOf(c).$D;
        }, m.$locale = function () {
          return D[this.$L];
        }, m.locale = function (t, e) {
          if (!t) return this.$L;
          var n = this.clone(),
            r = S(t, e, !0);
          return r && (n.$L = r), n;
        }, m.clone = function () {
          return O.w(this.$d, this);
        }, m.toDate = function () {
          return new Date(this.valueOf());
        }, m.toJSON = function () {
          return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function () {
          return this.$d.toISOString();
        }, m.toString = function () {
          return this.$d.toUTCString();
        }, M;
      }(),
      _ = b.prototype;
    return w.prototype = _, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", c], ["$y", h], ["$D", d]].forEach(function (t) {
      _[t[1]] = function (e) {
        return this.$g(e, t[0], t[1]);
      };
    }), w.extend = function (t, e) {
      return t.$i || (t(e, b, w), t.$i = !0), w;
    }, w.locale = S, w.isDayjs = p, w.unix = function (t) {
      return w(1e3 * t);
    }, w.en = D[g], w.Ls = D, w.p = {}, w;
  });
})(dayjs_min$1);
var dayjs_min = dayjs_min$1.exports;

var PlatformUtils = /*#__PURE__*/function () {
  function PlatformUtils() {
    _classCallCheck(this, PlatformUtils);
  }
  _createClass(PlatformUtils, null, [{
    key: "isMac",
    value: function isMac() {
      return /macintosh|mac os x/i.test(navigator.userAgent);
    }
  }, {
    key: "isWindows",
    value: function isWindows() {
      return /windows|win32/i.test(navigator.userAgent);
    }
  }, {
    key: "isIphone",
    value: function isIphone() {
      return /iphone\sos/i.test(navigator.userAgent);
    }
  }, {
    key: "isIpad",
    value: function isIpad() {
      return /(iPad).*OS\s([\d_]+)/.test(navigator.userAgent);
    }
  }, {
    key: "isAndroid",
    value: function isAndroid() {
      return /(Android)\s+([\d.]+)/.test(navigator.userAgent);
    }
  }, {
    key: "isMobile",
    value: function isMobile() {
      // 只考虑常见终端系统
      return /android|iphone|symbianos|windows phone|ipad|ipod/i.test(navigator.userAgent);
    }
  }]);
  return PlatformUtils;
}();

var isServerRendering = function () {
  try {
    return !(typeof window !== 'undefined' && document !== undefined);
  } catch (e) {
    return true;
  }
}();

export { CancelTypeEnum, Color, ColorGenerator, Config, DateUtils, DefaultOptions$1 as DefaultOptions, DisconnectReasonEnum, DomUtils, EnvUtils, EventDispatcher, FileUtils$1 as FileUtils, IdUtils, KeyCodeEnum, KeyCodeMap, KeyCodeModifiers, KeyboardTrap, MatchUtils, MathUtils, PlatformUtils, Snapshot, SnapshotHolder, SocketWrapper, StyleTransform, TaskStatusEnum, TaskSystem, TweenAnimation, TypeUtils, UrlUtils, applyOn, arrayDivision, arrayToMap, arrayToObject, arrayTotalize, curry, customAnimation, dayjs_min as dayjs, deduplicate, deepCopy, deepFreeze, difference, distinct, equal, groupById, intersection, isCustomError, isDefined, isLocalEnvironment, isServerRendering, isWrappedApi, merge, move, omit, parseUrlWithUrlParams, pick, range, remove, request$1 as request, requestFactory$1 as requestFactory, stopAllAnimation, toArray, toUpdateBy, toggle, useSocket, useTaskSystem };
